export const translation = {
  // Navbar
  nav_products: '製品',
  nav_production_scale: '生産規模',
  nav_brand_strength: 'ブランド力',
  nav_contact: 'お問い合わせ',
  nav_view_all: 'すべて見る',
  nav_language_label: '言語',

  // Product Categories - Main
  cat_nail_guns: 'コードレス釘打機シリーズ',
  cat_garden_tools: 'ガーデンツールシリーズ',
  cat_brushless: 'ブラシレスコードレスシリーズ',
  cat_workshop: 'ワークショップツール',
  cat_sharpening: 'プロフェッショナル研磨',

  // Nail Guns Categories
  cat_nail_4v: '4V',
  cat_nail_20v: '20V',
  cat_nail_ac: 'AC',

  // Garden Tools Categories
  cat_garden_chainsaw: 'チェーンソー＆剪定鋸',
  cat_garden_pole: '高枝鋸＆伸縮シリーズ',
  cat_garden_maintenance: 'ガーデンメンテナンス',

  // Brushless Categories
  cat_brushless_impact_drill: 'インパクトドリル＆レンチ',
  cat_brushless_impact_driver: 'ドライバーとインパクトレンチ',
  cat_brushless_angle_grinder: 'アングルグラインダー',

  // Workshop Categories
  cat_workshop_polisher: 'カーポリッシャー',
  cat_workshop_sander: 'サンダー＆表面処理',
  cat_workshop_glue_gun: 'ホットグルーガン',

  // Sharpening Categories
  cat_sharpening_workbench: '多機能研削ワークベンチ',
  cat_sharpening_drill_repair: 'ドリルビット修理機',
  cat_sharpening_engraving: '彫刻ツール',

  // ===== 製品詳細ページ =====
  breadcrumb_home: 'ホーム',
  breadcrumb_nail_guns: 'コードレス釘打機シリーズ',
  product_model: 'モデル',
  product_highlights: '製品の特長',
  product_overview: '製品概要',
  accessories_title: 'アクセサリー＆パーツ',
  product_specs: '製品仕様',

  // ===== 規格パラメータラベル =====
  spec_voltage: '電圧',
  spec_power: '出力',
  spec_weight: '重量',
  spec_battery: 'バッテリー',
  spec_charge_time: '充電時間',
  spec_speed: '回転数',
  spec_max_torque: '最大トルク',
  spec_chuck_size: 'チャックサイズ',
  spec_nail_type: '釘タイプ',
  spec_nail_length: '釘の長さ',
  spec_magazine: '装填容量',
  spec_firing_mode: '打ち込みモード',
  spec_blade_length: 'ブレード長さ',
  spec_cutting_capacity: '切断能力',
  spec_disc_size: 'ディスクサイズ',
  spec_opm: '振動数',
  spec_grinding_wheel: '砥石サイズ',
  spec_temperature: '作業温度',
  spec_glue_diameter: 'グルースティック径',
  spec_sequential: '順次打ち込み',
  spec_dimensions: '外形寸法',
  spec_noise_level: '騒音レベル',
  spec_color: 'カラー',
  spec_warranty: '保証期間',
  spec_certification: '認証規格',
  spec_max_pressure: '最大圧力',

  // ===== 規格値 =====
  spec_val_color_black_orange: 'ブラック / オレンジ',
  spec_val_color_silver_black: 'シルバー / ブラック',
  spec_val_color_black_red: 'ブラック / レッド',
  spec_val_warranty_24: '24ヶ月',
  spec_val_warranty_12: '12ヶ月',
  spec_val_nails_80: '80本',
  spec_val_nails_110: '110本',
  spec_val_nail_f: 'Fタイプ釘',
  spec_val_nail_t: 'Tタイプ釘',
  spec_val_nail_j: 'Jタイプ釘',
  spec_val_nail_u: 'Uタイプステープル',
  spec_val_nail_n: 'Nタイプコイル釘',
  spec_val_nail_b: 'Bタイプ釘',
  spec_val_nail_c: 'Cタイプ釘',
  spec_val_nail_d: 'Dタイプ釘',
  spec_val_nail_g: 'Gタイププロ釘',
  spec_val_nail_e: 'Eタイプ釘',

  all_products_nav: '全製品',

  // ===== 釘打機製品名 =====
  nail_gun_name_J_120: '4V タッカー',
  nail_gun_name_J_125: '4V タッカー',
  nail_gun_name_J_139: '4V タッカー',
  nail_gun_name_J_126: '4V タッカー',
  nail_gun_name_J_153: '4V タッカー',
  nail_gun_name_lk_4v_n50: 'LK-4V-N50 ミニNタイプ釘打機',
  nail_gun_name_lk_4v_b18: 'LK-4V-B18 ミニBタイプ釘打機',
  nail_gun_name_lk_4v_c25: 'LK-4V-C25 ミニCタイプ釘打機',
  nail_gun_name_lk_4v_d30: 'LK-4V-D30 ミニDタイプ釘打機',
  nail_gun_name_lk_4v_e40: 'LK-4V-E40 ミニEタイプ釘打機',
  nail_gun_name_J_128: '20V タッカー',
  nail_gun_name_J_129: '20V タッカー',
  nail_gun_name_J_133: '20V タッカー',
  nail_gun_name_J_145: '20V タッカー',
  nail_gun_name_J_147: '20V コードレスケーブルタッカー',
  nail_gun_name_J_150: '20V タッカー',
  nail_gun_name_J_156: '20V タッカー',
  nail_gun_name_lk_20v_d70: 'LK-20V-D70 リチウムDタイプ釘打機',
  nail_gun_name_lk_20v_e80: 'LK-20V-E80 リチウムEタイプ釘打機',
  nail_gun_name_lk_20v_g100: 'LK-20V-G100 リチウムフラッグシップ釘打機',
  nail_gun_name_J_112: 'AC タッカー',
  nail_gun_name_J_115: 'AC タッカー',
  nail_gun_name_J_118: 'AC タッカー',
  nail_gun_name_J_119: 'AC タッカー',
  nail_gun_name_J_123: 'AC タッカー',
  nail_gun_name_lk_ac_b50: 'LK-AC-B50 AC電動Bタイプ釘打機',
  nail_gun_name_lk_ac_c60: 'LK-AC-C60 AC電動Cタイプ釘打機',
  nail_gun_name_lk_ac_d70: 'LK-AC-D70 AC電動Dタイプ釘打機',
  nail_gun_name_lk_ac_e80: 'LK-AC-E80 AC電動Eタイプ釘打機',
  nail_gun_name_lk_ac_g100: 'LK-AC-G100 AC電動フラッグシップ釘打機',

  // ===== Nail Guns Accessories =====
  

  accessory_1_name: '20Vリチウムバッテリーパック',
  accessory_1_desc: '大容量リチウムバッテリー、持続的な電力を供給',
  accessory_2_name: '急速充電器',
  accessory_2_desc: '60分急速充電、効率的で便利',
  accessory_3_name: '収納ケース',
  accessory_3_desc: '耐久性のある収納ケース、携帯・保管に便利',
  accessory_4_name: 'アクセサリーキット',
  accessory_4_desc: '一般的な交換部品、使用寿命を延長',
  accessory_5_name: '安全保護メガネ',
  accessory_5_desc: 'プロフェッショナル保護、安全な作業を確保',
  accessory_6_name: 'ベルトフック',
  accessory_6_desc: '携帯に便利、いつでも手の届く場所に',
  accessory_7_name: 'クリーニング＆メンテナンスキット',
  accessory_7_desc: 'プロフェッショナルメンテナンスツール、最高の状態を維持',
  accessory_8_name: '取扱説明書',
  accessory_8_desc: '詳細な操作ガイド、すぐに使いこなせる',

  // ===== Garden Tools Accessories =====
  garden_accessory_1_name: '20Vリチウムバッテリーパック',
  garden_accessory_1_desc: '大容量リチウムバッテリー、持続的な電力を供給',
  garden_accessory_2_name: '急速充電器',
  garden_accessory_2_desc: '60分急速充電、効率的で便利',
  garden_accessory_3_name: '交換ブレード',
  garden_accessory_3_desc: '高品質交換ブレード、最高の切断性能を維持',
  garden_accessory_4_name: '収納ケース',
  garden_accessory_4_desc: '耐久性のある収納ケース、携帯・保管に便利',
  garden_accessory_5_name: '保護グローブ',
  garden_accessory_5_desc: 'プロフェッショナル保護グローブ、安全な作業を確保',
  garden_accessory_6_name: 'ブレード研磨ツール',
  garden_accessory_6_desc: 'ブレードを鋭く保ち、使用寿命を延長',
  garden_accessory_7_name: 'クリーニング＆メンテナンスキット',
  garden_accessory_7_desc: 'プロフェッショナルメンテナンスツール、最高の状態を維持',
  garden_accessory_8_name: '取扱説明書',
  garden_accessory_8_desc: '詳細な操作ガイド、すぐに使いこなせる',

//12V 起子机key
brushless_pt_name: '取り外し可能なビット収納クリップ',
brushless_pt_desc: '3つの標準六角スロットを備え、常用ビット3本をしっかり収納。作業中にすぐ取り出せ、アクセサリーを探す手間を省きます。',

  // ===== Brushless Accessories =====
  // brushless_accessory_battery: 'リチウムバッテリーパック',
  // brushless_accessory_battery_desc: '大容量リチウムバッテリー、急速充電、長時間稼働、残量表示付き',
  // brushless_accessory_charger: 'スマート充電器',
  // brushless_accessory_charger_desc: '急速充電技術、バッテリー状態をスマートに認識、安全で効率的',
  // brushless_accessory_drill_bits: 'ドリルビットセット',
  // brushless_accessory_drill_bits_desc: '多規格ドリルビットセット、木材・金属・コンクリートなど多種材料対応',
  // brushless_accessory_case: '工具収納ケース',
  // brushless_accessory_case_desc: '耐久性のある収納ケース、全アクセサリーの携帯・保管に便利',
  // brushless_accessory_belt_clip: 'ベルトクリップ',
  // brushless_accessory_belt_clip_desc: '調整可能なベルトクリップ、工具を常に携帯できる',
  // brushless_accessory_side_handle: 'サイドハンドル',
  // brushless_accessory_side_handle_desc: 'サブハンドルでより良いコントロールと安定性を提供',
  // brushless_accessory_depth_gauge: '深度ゲージ',
  // brushless_accessory_depth_gauge_desc: '穿孔深度を精密制御、作業精度を確保',
  // brushless_accessory_manual: '取扱説明書',
  // brushless_accessory_manual_desc: '詳細な操作ガイドと重要な安全上の注意事項',

  // ===== Workshop Accessories (Polisher) =====
  workshop_accessory_polishing_pads: '研磨パッドセット',
  workshop_accessory_polishing_pads_desc: '各種硬度の研磨パッド、粗研磨と精研磨に対応',
  workshop_accessory_backing_plate: 'バッキングプレート',
  workshop_accessory_backing_plate_desc: '高品質バッキングプレート、研磨パッドの確実な取り付けを保証',
  workshop_accessory_polishing_compound: 'ポリッシングコンパウンド',
  workshop_accessory_polishing_compound_desc: 'プロフェッショナル研磨コンパウンド、傷を除去し塗装面の光沢を回復',
  workshop_accessory_microfiber_towels: 'マイクロファイバータオル',
  workshop_accessory_microfiber_towels_desc: '柔らかく吸水性が高く、塗装面に優しい、クリーニング・研磨両用',
  workshop_accessory_extension_cord: '延長コード',
  workshop_accessory_extension_cord_desc: '延長コードで作業範囲を拡大',
  workshop_accessory_carrying_bag: '収納バッグ',
  workshop_accessory_carrying_bag_desc: 'ポータブル収納バッグ、携帯・保管に便利',
  workshop_accessory_safety_glasses: '安全保護メガネ',
  workshop_accessory_safety_glasses_desc: 'プロフェッショナル保護メガネ、目を安全に保護',
  workshop_accessory_manual: '取扱説明書',
  workshop_accessory_manual_desc: '詳細な操作ガイドとメンテナンス説明、すぐに使いこなせる',

  // ===== Workshop Sander Accessories =====
  workshop_sander_accessory_1_name: 'サンドペーパーセット',
  workshop_sander_accessory_1_desc: '多粒度サンドペーパーの組み合わせ、粗研磨から精研磨まで対応',
  workshop_sander_accessory_2_name: '集塵袋',
  workshop_sander_accessory_2_desc: '専用集塵袋、高効率で粉塵を除去し作業環境を清潔に保つ',
  workshop_sander_accessory_3_name: '研磨バッキングプレート',
  workshop_sander_accessory_3_desc: '交換用バッキングプレート、サンドペーパーを平らで密着させてより良い結果に',
  workshop_sander_accessory_4_name: 'ディテール研磨ヘッド',
  workshop_sander_accessory_4_desc: '隅や細部向けの補助研磨アタッチメント',
  workshop_sander_accessory_5_name: '安全保護メガネ',
  workshop_sander_accessory_5_desc: '透明保護メガネ、研磨粉塵から目を保護',
  workshop_sander_accessory_6_name: '防塵マスク',
  workshop_sander_accessory_6_desc: '高過滤効率防塵マスク、長時間作業時の健康を守る',
  workshop_sander_accessory_7_name: '収納バッグ',
  workshop_sander_accessory_7_desc: 'ポータブル収納バッグ、工具と全アクセサリーの携帯に便利',
  workshop_sander_accessory_8_name: '取扱説明書',
  workshop_sander_accessory_8_desc: '詳細な操作ガイドとメンテナンス説明、すぐに使いこなせる',

  // ===== Workshop Glue Gun Accessories =====
  workshop_glue_accessory_1_name: 'ホットグルースティックセット',
  workshop_glue_accessory_1_desc: '標準11mmホットグルースティック、100本入り、強力な接着力、広い用途',
  workshop_glue_accessory_2_name: '精密ノズル',
  workshop_glue_accessory_2_desc: '細口精密ノズル、精細な接着と小面積への塗布に適した',
  workshop_glue_accessory_3_name: 'ワイドノズル',
  workshop_glue_accessory_3_desc: 'ワイドノズルで大面積への素早い塗布が可能、作業効率を向上',
  workshop_glue_accessory_4_name: '耐熱スタンド',
  workshop_glue_accessory_4_desc: '耐高温スタンドでグルーガンを置いた際に台面を保護',
  workshop_glue_accessory_5_name: 'クリーニングブラシ',
  workshop_glue_accessory_5_desc: '専用クリーニングブラシ、ノズルの残留グルーを除去し使用寿命を延長',
  workshop_glue_accessory_6_name: 'ノズル延長チューブ',
  workshop_glue_accessory_6_desc: '延長チューブで深い場所や狭い空間へのグルー塗布が可能',
  workshop_glue_accessory_7_name: '収納バッグ',
  workshop_glue_accessory_7_desc: 'ポータブル収納バッグ、グルーガンと全アクセサリーの携帯に便利',
  workshop_glue_accessory_8_name: '取扱説明書',
  workshop_glue_accessory_8_desc: '詳細な操作ガイドと重要な安全上の注意事項',

  // ===== Sharpening Accessories =====
  sharpening_accessory_grinding_wheels: '砥石セット',
  sharpening_accessory_grinding_wheels_desc: '各種粒度の砥石、粗研削と精研削のニーズに対応',
  sharpening_accessory_angle_guide: '角度ガイド',
  sharpening_accessory_angle_guide_desc: '精密角度制御ガイド、研削角度の一貫性を確保',
  sharpening_accessory_honing_compound: '研磨コンパウンド',
  sharpening_accessory_honing_compound_desc: 'プロフェッショナル研磨コンパウンド、傷を除去し塗装面の光沢を回復',
  sharpening_accessory_safety_shield: '安全シールド',
  sharpening_accessory_safety_shield_desc: '透明保護シールド、研削屑の飛散を防止',
  sharpening_accessory_work_light: 'ワークライト',
  sharpening_accessory_work_light_desc: 'LED作業灯、精密研削に十分な照明を提供',
  sharpening_accessory_dressing_tool: 'ドレッシングツール',
  sharpening_accessory_dressing_tool_desc: '砥石ドレッシングツール、砥石を平らで鋭く保つ',
  sharpening_accessory_measuring_gauge: '角度測定ゲージ',
  sharpening_accessory_measuring_gauge_desc: '精密角度測定ゲージ、刃の角度をチェック',
  sharpening_accessory_manual: '取扱説明書',
  sharpening_accessory_manual_desc: '詳細な操作ガイドとメンテナンス説明',

  // ===== Brushless Nested Keys =====
  'products.brushless.categories.drill': 'ドライバーと電動ドリル',
  'products.brushless.drill.001.model': 'P0L-DW01-4V',
  'products.brushless.drill.001.name': '4V 電動ドライバー',
  'products.brushless.drill.001.description': '4V 電動ドライバー',
  'products.brushless.drill.002.model': 'P0L-DW01B-4V',
  'products.brushless.drill.002.name': '4V 電動ドライバー',
  'products.brushless.drill.002.description': '4V 電動ドライバー',
  'products.brushless.drill.003.model': 'P0L-DW02-4V',
  'products.brushless.drill.003.name': '4V 電動ドライバー',
  'products.brushless.drill.003.description': '4V 電動ドライバー',
  'products.brushless.drill.004.model': 'J0Z-DW07-13',
  'products.brushless.drill.004.name': '20V ブラシレス振動ドリル',
  'products.brushless.drill.004.description': '20V ブラシレス振動ドリル',
  'products.brushless.drill.005.model': 'J0Z-DW08A-10',
  'products.brushless.drill.005.name': '12V 振動ドリル',
  'products.brushless.drill.005.description': '12V 振動ドリル',
  'products.brushless.drill.006.model': 'J0Z-DW09-13',
  'products.brushless.drill.006.name': '20V ブラシレスドライバドリル',
  'products.brushless.drill.006.description': '20V ブラシレスドライバドリル',
  'products.brushless.drill.007.model': 'LK-BL-ID-20V-007',
  'products.brushless.drill.007.name': '12V ドライバドリル',
  'products.brushless.drill.007.description': '12V ドライバドリル',
  'products.brushless.drill.008.model': 'LK-BL-IW-20V-008',
  'products.brushless.drill.008.name': '20Vブラシレスコンパクトインパクトレンチ',
  'products.brushless.drill.008.description': '20Vブラシレスコンパクトインパクトレンチ',
  'products.brushless.drill.009.model': 'LK-BL-ID-20V-009',
  'products.brushless.drill.009.name': '20Vブラシレススマートインパクトドリル',
  'products.brushless.drill.009.description': '20Vブラシレススマートインパクトドリル',
  'products.brushless.drill.010.model': 'LK-BL-IW-20V-010',
  'products.brushless.drill.010.name': '20Vブラシレスフラッグシップインパクトレンチ',
  'products.brushless.drill.010.description': '20Vブラシレスフラッグシップインパクトレンチ',
  'products.brushless.driver.001.model': 'P0L-DW05-12V',
  'products.brushless.driver.001.name': '12V ブラシレスインパクトドライバー',
  'products.brushless.driver.001.description': '12V ブラシレスインパクトドライバー',
  'products.brushless.driver.002.model': 'P0L-DW07-20V',
  'products.brushless.driver.002.name': '20V インパクトドライバー',
  'products.brushless.driver.002.description': '20V インパクトドライバー',
  'products.brushless.driver.003.model': 'POL-DW04M-280',
  'products.brushless.driver.003.name': '20V ブラシレスインパクトドライバー',
  'products.brushless.driver.003.description': '20V ブラシレスインパクトドライバー',
  'products.brushless.driver.004.model': 'P0B-DW02BL-500',
  'products.brushless.driver.004.name': '20V ブラシレスインパクトレンチ',
  'products.brushless.driver.004.description': '20V ブラシレスインパクトレンチ',
  'products.brushless.driver.005.model': 'P0B-DW03BL-800',
  'products.brushless.driver.005.name': '20V ブラシレスインパクトレンチ',
  'products.brushless.driver.005.description': '20V ブラシレスインパクトレンチ',
  'products.brushless.driver.006.model': 'LK-BL-DR-20V-006',
  'products.brushless.driver.006.name': '20Vブラシレスプロフェッショナルドライバー',
  'products.brushless.driver.006.description': '20Vブラシレスプロフェッショナルドライバー',
  'products.brushless.driver.007.model': 'LK-BL-DR-20V-007',
  'products.brushless.driver.007.name': '20Vブラシレス軽量ドライバー',
  'products.brushless.driver.007.description': '20Vブラシレス軽量ドライバー',
  'products.brushless.driver.008.model': 'LK-BL-DR-20V-008',
  'products.brushless.driver.008.name': '20Vブラシレススマートドライバー',
  'products.brushless.driver.008.description': '20Vブラシレススマートドライバー',
  'products.brushless.driver.009.model': 'LK-BL-DR-20V-009',
  'products.brushless.driver.009.name': '20Vブラシレス直角ドライバー',
  'products.brushless.driver.009.description': '20Vブラシレス直角ドライバー',
  'products.brushless.driver.010.model': 'LK-BL-DR-20V-010',
  'products.brushless.driver.010.name': '20Vブラシレスフラッグシップドライバー',
  'products.brushless.driver.010.description': '20Vブラシレスフラッグシップドライバー',
  //角磨机
  'products.brushless.grinder.001.model': 'S0M-DW01-100',
  'products.brushless.grinder.001.name': '20V ブラシレスディスクグラインダー',
  'products.brushless.grinder.001.description': '20V ブラシレスディスクグラインダー',
  'products.brushless.grinder.002.model': 'LK-BL-AG-20V-002',
  'products.brushless.grinder.002.name': '20Vブラシレスアングルグラインダー125mm',
  'products.brushless.grinder.002.description': '20Vブラシレスアングルグラインダー（大径）',
  'products.brushless.grinder.003.model': 'LK-BL-AG-20V-003',
  'products.brushless.grinder.003.name': '20Vブラシレスアングルグラインダー150mm',
  'products.brushless.grinder.003.description': '20Vブラシレスアングルグラインダー（ミニ）',
  'products.brushless.grinder.004.model': 'LK-BL-AG-20V-004',
  'products.brushless.grinder.004.name': '20Vブラシレス可変速アングルグラインダー',
  'products.brushless.grinder.004.description': '20Vブラシレス可変速アングルグラインダー',
  'products.brushless.grinder.005.model': 'LK-BL-AG-20V-005',
  'products.brushless.grinder.005.name': '20Vブラシレスプロアングルグラインダー',
  'products.brushless.grinder.005.description': '20Vブラシレスプロアングルグラインダー',
  'products.brushless.grinder.006.model': 'LK-BL-AG-20V-006',
  'products.brushless.grinder.006.name': '20Vブラシレス高速アングルグラインダー',
  'products.brushless.grinder.006.description': '20Vブラシレス高速アングルグラインダー',
  'products.brushless.grinder.007.model': 'LK-BL-AG-20V-007',
  'products.brushless.grinder.007.name': '20Vブラシレス軽量アングルグラインダー',
  'products.brushless.grinder.007.description': '20Vブラシレス軽量アングルグラインダー',
  'products.brushless.grinder.008.model': 'LK-BL-AG-20V-008',
  'products.brushless.grinder.008.name': '20Vブラシレス多機能アングルグラインダー',
  'products.brushless.grinder.008.description': '20Vブラシレス多機能アングルグラインダー',
  'products.brushless.grinder.009.model': 'LK-BL-AG-20V-009',
  'products.brushless.grinder.009.name': '20Vブラシレススマートアングルグラインダー',
  'products.brushless.grinder.009.description': '20Vブラシレススマートアングルグラインダー',
  'products.brushless.grinder.010.model': 'LK-BL-AG-20V-010',
  'products.brushless.grinder.010.name': '20Vブラシレスフラッグシップアングルグラインダー',
  'products.brushless.grinder.010.description': '20Vブラシレスフラッグシップアングルグラインダー',

  // ===== Garden Tools Nested Keys (High Branch Saw & Lawn Care) =====
  'products.gardenTools.categories.hedgeTrimmer': 'チェーンソー',
  'products.gardenTools.categories.poleSaw': '高枝鋸＆伸縮シリーズ',
  'products.gardenTools.categories.lawnCare': 'ガーデンメンテナンス',

  'products.gardenTools.polePruner.001.name': 'N0HX-DW01B-410',
  'products.gardenTools.polePruner.001.description': '20V 充電式高枝ヘッジトリマー',
  'products.gardenTools.polePruner.002.name': 'N0HC-DW01-32',
  'products.gardenTools.polePruner.002.description': '20V 充電式伸縮高枝切りバサミ',
  'products.gardenTools.polePruner.003.name': 'M0HL-DW08-8C',
  'products.gardenTools.polePruner.003.description': '20V 充電式高枝ポールソー',
  'products.gardenTools.polePruner.004.name': 'LK-GT-PP-20V-004',
  'products.gardenTools.polePruner.004.description': '20Vコードレス軽量高枝鋸',
  'products.gardenTools.polePruner.005.name': 'LK-GT-PP-20V-005',
  'products.gardenTools.polePruner.005.description': '20Vコードレス重作業高枝鋸',
  'products.gardenTools.polePruner.006.name': 'LK-GT-PP-20V-006',
  'products.gardenTools.polePruner.006.description': '20Vコードレス折りたたみ高枝鋸',
  'products.gardenTools.polePruner.007.name': 'LK-GT-PP-20V-007',
  'products.gardenTools.polePruner.007.description': '20Vコードレスプロフェッショナル高枝鋸',
  'products.gardenTools.polePruner.008.name': 'LK-GT-PP-20V-008',
  'products.gardenTools.polePruner.008.description': '20Vコードレススマート高枝鋸',
  'products.gardenTools.polePruner.009.name': 'LK-GT-PP-20V-009',
  'products.gardenTools.polePruner.009.description': '20Vコードレス人間工学高枝鋸',
  'products.gardenTools.polePruner.010.name': 'LK-GT-PP-20V-010',
  'products.gardenTools.polePruner.010.description': '20Vコードレス多機能高枝鋸',

  'products.gardenTools.lawnCare.001.name': 'S1L-DW03-104',
  'products.gardenTools.lawnCare.001.description': '20V 充電式チェンソー研磨機',
  'products.gardenTools.lawnCare.002.name': 'S0L-DW04-108',
  'products.gardenTools.lawnCare.002.description': '85W チェンソー研磨機',
  'products.gardenTools.lawnCare.003.name': 'LK-GT-LC-20V-003',
  'products.gardenTools.lawnCare.003.description': '40V 大出力芝刈りトリマー',
  'products.gardenTools.lawnCare.004.name': 'LK-GT-LC-20V-004',
  'products.gardenTools.lawnCare.004.description': '20Vブラシレスヘッジトリマー',
  'products.gardenTools.lawnCare.005.name': 'LK-GT-LC-20V-005',
  'products.gardenTools.lawnCare.005.description': '20Vリチウム芝スカリファイアー',
  'products.gardenTools.lawnCare.006.name': 'LK-GT-LC-20V-006',
  'products.gardenTools.lawnCare.006.description': '20Vリチウム芝エッジャー',
  'products.gardenTools.lawnCare.007.name': 'LK-GT-LC-20V-007',
  'products.gardenTools.lawnCare.007.description': '20Vリチウム多機能ガーデンツール',
  'products.gardenTools.lawnCare.008.name': 'LK-GT-LC-20V-008',
  'products.gardenTools.lawnCare.008.description': '40Vブラシレスプロ芝刈りトリマー',
  'products.gardenTools.lawnCare.009.name': 'LK-GT-LC-20V-009',
  'products.gardenTools.lawnCare.009.description': '20Vリチウム芝刈り機',
  'products.gardenTools.lawnCare.010.name': 'LK-GT-LC-20V-010',
  'products.gardenTools.lawnCare.010.description': '20Vリチウムプロガーデンメンテナンスセット',

  'products.gardenTools.hedgeTrimmer.001.model': 'M0L-DW03-5C',
  'products.gardenTools.hedgeTrimmer.001.description': '12V 5インチ園芸ノコギリ',
  'products.gardenTools.hedgeTrimmer.002.model': 'M0L-DW03-6C',
  'products.gardenTools.hedgeTrimmer.002.description': '20V 6インチ園芸ノコギリ',
  'products.gardenTools.hedgeTrimmer.003.model': 'M0L-DW05-10C',
  'products.gardenTools.hedgeTrimmer.003.description': '20V 10インチチェンソー',
  'products.gardenTools.hedgeTrimmer.004.model': 'M0L-DW06-8C',
  'products.gardenTools.hedgeTrimmer.004.description': '20V 8インチブラシレスチェンソー',
  'products.gardenTools.hedgeTrimmer.005.model': 'LK-GT-CS-20V-005',
  'products.gardenTools.hedgeTrimmer.005.description': '20Vリチウムミニチェーンソー',
  'products.gardenTools.hedgeTrimmer.006.model': 'LK-GT-CS-20V-006',
  'products.gardenTools.hedgeTrimmer.006.description': '20Vリチウムポール剪定鋸',
  'products.gardenTools.hedgeTrimmer.007.model': 'LK-GT-CS-20V-007',
  'products.gardenTools.hedgeTrimmer.007.description': '20Vリチウムヘッジトリマー',
  'products.gardenTools.hedgeTrimmer.008.model': 'LK-GT-CS-40V-008',
  'products.gardenTools.hedgeTrimmer.008.description': '40Vブラシレス大出力チェーンソー',
  'products.gardenTools.hedgeTrimmer.009.model': 'LK-GT-CS-20V-009',
  'products.gardenTools.hedgeTrimmer.009.description': '20Vリチウム伸縮剪定鋸',
  'products.gardenTools.hedgeTrimmer.010.model': 'LK-GT-CS-20V-010',
  'products.gardenTools.hedgeTrimmer.010.description': '20Vリチウムプロフェッショナル剪定鋸',

  // ===== 各サブカテゴリ独立製品説明（詳細ページ用）=====
  nail_4v_description: '本4Vミニコードレス釘打機は超軽量設計で重量わずか0.8kg、片手での楽な操作が可能です。4Vリチウム電池は90分充電で約300本の釘打ちに対応し、室内木工や家具組立などの精密作業に最適です。滑り止めゴムグリップ設計で長時間使用でも快適、DIYファンと木工愛好家の理想的な選択肢です。',
  nail_20v_description: '本20Vリチウム釘打機は高出力ブラシレスモーターを搭載し、安定した強力な打ち込み力で硬木や厚い板材も楽に対応します。60分急速充電対応の大容量バッテリーで終日高強度作業が可能です。防塵・耐衝撃ハウジングが過酷な施工現場環境に適応し、プロの建設作業者や熟練大工の信頼できるパートナーです。',
  nail_ac_description: '本AC電源釘打機は直驅設計を採用し、電池不要で途切れない高強度連続作業を実現します。800Wの強力出力で毎秒最大1.5本の打ち込みが可能、大規模建設工事や流れ作業生産ラインに最適です。安定した滑り止めベース設計があらゆる作業台面での安全で安定した操作を保証します。',
  brushless_drill_description: '本ブラシレスインパクトドリル/レンチは高性能ブラシレスモーターで最大80N·mのトルクを発揮し、穿孔・締付け・分解のあらゆる作業を網羅します。2速クラッチ設定で柔軟なモード切替が可能、内蔵LED照明とクイックロックチャックが作業効率を向上させます。全金属精密ギアボックスが高い伝達効率と長期耐久性を保証します。',
  brushless_driver_description: '本ブラシレスインパクトドライバーは最大180N·mのインパクトトルクを発揮し、重量わずか1.3kgのコンパクトボディで狭い場所への進入も容易です。4速モードが様々な作業シーンに正確に対応し、3点式LED照明が全角度から作業の影を排除します。クイックリリース六角チャックが全サイズのビットに対応、設置・修理作業の効率的なツールです。',
  brushless_grinder_description: '本ブラシレスアングルグラインダーは8500RPMに達し、インテリジェント電子過負荷保護がモーターを自動保護します。ソフトスタート機能がキックバックを防止し、ツールフリーのクイックディスク交換システムが交換時間を大幅削減します。交換可能なガードが切断と研削の両作業に対応、金属切断・溶接清掃・表面研削など多様な工況に適しています。',
  garden_chainsaw_description: '本電動チェーンソー/剪定鋸は優質合金鋼チェーンがチェーン速度10m/sで木材を効率的に切断し、断面は整然と滑らかです。内蔵自動潤滑システムがチェーンに持続的に給油し、ツールフリーのクイックリリースガイドバーがメンテナンスを簡略化します。安全チェーンブレーキが瞬時に応答して作業安全を保障し、低振動人間工学設計が疲労を大幅低減します。',
  garden_pole_description: '本高枝鋸は伸縮ポールが最大3mまで延長でき、はしごなしで3-5mの高さの枝に安全に届きます。鋸ヘッドが0-60°の多角度調整に対応し、軽量の3.2kgポールが頭上作業の腕の疲れを最小化します。内蔵過負荷自動保護が信頼性の高い安全性を確保し、果樹園管理と街路樹剪定のプロ向けツールです。',
  garden_lawn_description: '本ガーデンメンテナンスツールはワイドな作業ヘッドで1回のパスでより広い面積をカバーし、作業効率を大幅向上します。折りたたみハンドルで収納体積を半分に削減し、多段階高さ調整で様々な身長のユーザーに対応します。低騒音モーターが78dB未満で住宅地での作業に最適です。',
  workshop_polisher_description: '本プロフェッショナルカーポリッシャーは特許取得済みデュアルアクション軌道運動技術を採用し、均一で繊細な研磨を実現して旋傷の発生を効果的に防止します。6段階の速度設定が粗研磨からミラー仕上げまでの全工程をカバーし、初心者でもプロ級の研磨結果を実現できます。',
  workshop_sander_description: '本オービタルサンダーは精密偏心軌道設計で均一でプロフェッショナルな表面仕上げを実現します。内蔵集塵システムが研削粉塵を効率的に捕集し、マジックテープ式クイック交換ディスクでツール不要に瞬時に目の粗さを変更できます。防振ハンドルが長時間使用中の疲労を防止し、木工精加工や塗料剥離に最適です。',
  workshop_glue_description: '本ホットグルーガンはわずか60秒で作業温度に達し、迅速に作業開始できます。特許取得済みの滴り防止設計でトリガーを離すと即座に接着剤の流れが止まります。内蔵過熱保護が安全な使用を確保し、模型製作・クラフト・家具修復など幅広い接着シーンに対応します。',
  sharpening_workbench_description: '本多機能研削ワークベンチは0-45°無段階調整対応の精密角度ガイドレールを搭載し、毎回一貫した正確な研削角度を実現します。恒速研削モーターが平坦で均一な研削面を保証し、水冷槽が刃を持続冷却して熱による損傷を防止します。プロシェフと木工師傅の研磨に欠かせないツールです。',
  sharpening_drill_description: '本ドリルビット修理機はスマート自動角度位置決めシステムが手動調整なしで最適な研削角度を識別します。3-13mmの全ての直柄ドリルビットに対応し、高精度3爪自動調心チャックが優れた同軸精度を確保します。直感的な操作設計で5分以内に習熟でき、工場での一括修理と個人工具メンテナンスに最適です。',
  sharpening_engraving_description: '本彫刻ツールは30,000RPMに達し、滑らかな彫刻面と卓越したディテール表現力を実現します。無段階速度制御がゆっくりとした精密トレースから高速彫刻まで自由に切替可能です。スリムなペングリップ設計が自然な握り感で長時間の精密彫刻でも疲れません。',

  // ===== Home Page Hero =====
  hero1_subtitle: 'LEIMING TOOLS',
  hero1_title: 'プロフェッショナル電動工具メーカー',
  hero1_desc: '50年の電動工具研究開発・製造への専念',
  hero1_cta: '詳しく見る',
  hero2_subtitle: 'INNOVATION',
  hero2_title: 'イノベーション主導、品質リーディング',
  hero2_desc: '500以上の特許技術・グローバル認証取得',
  hero2_cta: '製品を見る',
  hero3_subtitle: 'QUALITY',
  hero3_title: '匠の品質、信頼に値する',
  hero3_desc: 'ISO認証・厳格な品質管理',
  hero3_cta: '品質保証',
  hero4_subtitle: 'SERVICE',
  hero4_title: 'グローバルサービス、安心サポート',
  hero4_desc: '200以上のサービスセンター・24時間対応',
  hero4_cta: 'お問い合わせ',
  hero5_subtitle: 'PARTNERSHIP',
  hero5_title: '共に勝利し、共に未来を創る',
  hero5_desc: 'グローバル戦略パートナー',
  hero5_cta: 'パートナーになる',

  latest_products: '最新製品',
  product_showcase: '製品紹介',
  more_products: 'もっと見る',
  new_brushless_drill: '新型ブラシレスコードレスドリル',
  new_cordless_nail_gun: '新型コードレス釘打機',
  product_tag_new: 'NEW',
  new_cordless_nail_gun_home: '新型シリンダー釘打ち機',

  // ===== Product Showcase =====
  product_cordless_impact_wrench: 'コードレスインパクトレンチ',
  product_cordless_circular_saw: 'コードレス丸鋸',
  product_cordless_angle_grinder: 'コードレスアングルグラインダー',
  product_cordless_jigsaw: 'コードレスジグソー',
  product_cordless_reciprocating_saw: 'コードレスセーバーソー',

  // ===== Categories =====
  cat_title: '製品シリーズを探す',
  cat1_title: '電動工具',
  cat1_count: '500以上の製品',
  cat2_title: '手工具',
  cat2_count: '300以上の製品',
  cat3_title: '工具収納',
  cat3_count: '150以上の製品',
  cat4_title: 'アウトドア機器',
  cat4_count: '200以上の製品',
  shop_now: '今すぐ購入',

  // ===== Production Scale =====
  prod_label: '生産規模',
  prod_title: '生産規模',
  prod_subtitle: '世界トップクラスの電動工具製造拠点',
  stat1_num: '300+',
  stat1_label: '製品モデル',
  stat2_num: '40,000㎡',
  stat2_label: '生産拠点',
  stat3_num: '100+',
  stat3_label: '販売国',
  stat4_num: '10+',
  stat4_label: '販売チャネル',
  stat5_num: '500人',
  stat5_label: 'プロフェッショナルチーム',
  facility_title: '先進生産施設',
  fac1_title: '自動化生産ライン',
  fac1_desc: '国際的に先進的な自動化生産設備を導入し、製品の安定した品質を確保',
  fac2_title: '品質検査センター',
  fac2_desc: 'プロフェッショナルな検査機器を装備し、すべての製品が厳格な品質検査を受けている',
  fac3_title: 'エコ生産',
  fac3_desc: '環境にやさしい素材とプロセスを使用し、国際的な環境基準に準拠',
  fac4_title: '迅速な配送',
  fac4_desc: '完全な物流システムにより、製品を迅速にグローバルに届ける',

  // ===== Brand Strength =====
  brand_label: 'BRAND STRENGTH',
  brand_title: 'ブランド力',
  brand_subtitle: 'グローバルに信頼されるプロフェッショナルツールブランド',
  mile1_year: '1998-2005',
  mile1_title: '上海発祥点ブランド誕生',
  mile1_desc: '電動工具製造に注力開始',
  mile2_year: '2006-2018',
  mile2_title: '技術に深く根ざし、必要な資格をすべて備えている',
  mile2_desc: '製品が世界50以上の国々に輸出',
  mile3_year: '2019-2019',
  mile3_title: '無錫には、生産と販売を分離した2つの会社が設立された。',
  mile3_desc: '100以上の特許技術を取得',
  mile4_year: '2020-2025',
  mile4_title: '2020年以降、この4大企業は協力関係を築き、サプライチェーン全体が28年以上にわたって成熟してきた。',
  mile4_desc: 'グローバルトップ3工具ブランドのひとつに',
  cert_title: '資格認証と栄誉',
  cert1: 'ISO 14001 環境マネジメントシステム認証',
  cert2: 'BSCI 社会的責任認証',
  cert3: 'CE 欧州安全認証',
  cert4: 'UL 米国安全認証',
  cert5: 'GS ドイツ安全認証',
  cert6: 'CQC 中国品質認証センター製品認証',
  cert7: '120件以上の実用新案および発明特許',
  cert8: '上海電気行業協会理事単位',
  cert9: '8年連続「契約遵守・信用尊重企業」に選出',
  partner_title: 'グローバル戦略パートナー',
  partner1_name: 'Home Depot',
  partner1_desc: '北米最大のホームセンターチェーン',
  partner2_name: "Lowe's",
  partner2_desc: '米国有名ホームセンターチェーン',
  partner3_name: 'Amazon',
  partner3_desc: 'グローバルECプラットフォーム戦略連携',
  partner4_name: 'Grainger',
  partner4_desc: '産業用品流通大手',

  // ===== Deep Engagement =====
  deep_title: '電動工具業界への深い関与',
  deep_subtitle: '専門・専注・専心',
  deep_stat1_num: '50年',
  deep_stat1_label: '業界経験',
  deep_stat2_num: '500以上',
  deep_stat2_label: '特許技術',
  deep_stat3_num: '100以上',
  deep_stat3_label: '国と地域',
  deep_stat4_num: '1000万以上',
  deep_stat4_label: '信頼ユーザー',
  feat1_title: '品質保証',
  feat1_desc: '厳格な品質管理、すべての製品が複数の検査工程を経ている',
  feat2_title: 'グローバルサービス',
  feat2_desc: '200以上のサービスセンター、24時間迅速対応',
  feat3_title: 'R&Dイノベーション',
  feat3_desc: '継続的なR&D投資、業界技術開発をリード',
  feat4_title: '豊富な製品',
  feat4_desc: '500以上の製品モデル、様々なニーズに対応',
  feat5_title: '安全・信頼',
  feat5_desc: '国際安全認証取得済み、安心してお使いいただける',

  // ===== CTA =====
  cta_title: '優良パートナーを探しています',
  cta_subtitle: '共に素晴らしい未来を創り、皆様との協力を心よりお待ちしています',
  cta_btn: '今すぐお問い合わせ',

  // ===== Contact =====
  contact_title: 'お問い合わせ',
  contact_us_label: 'CONTACT US',
  contact_subtitle: '私たちは常にプロフェッショナルなサービスを提供します',
  contact_address_label: '会社所在地',
  contact_address: '上海市松江区東京鎮茂生路202巷1号',
  contact_phone_label: '電話番号',
  contact_phone: '+86 400-888-8888',
  contact_mobile_label: '携帯電話',
  contact_mobile: '+86 150 0031 5400',
  contact_landline_label: '固定電話',
  contact_landline: '+86 21 64199981',
  contact_email_label: 'メールアドレス',
  contact_email: 'cherry@dongweitools.net',
  contact_time_label: '営業時間',
  contact_time_value: '月曜〜金曜  09:00 – 18:00',
  contact_company_title: 'プロフェッショナル電動工具メーカー',
  contact_company_subtitle: 'グローバルリーダー・卓越した品質・信頼に値する',
  form_title: 'メッセージを送る',
  form_subtitle: '以下の情報を入力してください。24時間以内にご返信いたします',
  form_name: 'お名前',
  form_phone: '電話番号',
  form_email: 'メールアドレス',
  form_company: '会社名',
  form_message: 'メッセージ内容',
  form_required: '*',
  form_name_placeholder: 'お名前を入力してください',
  form_phone_placeholder: '電話番号を入力してください',
  form_email_placeholder: 'メールアドレスを入力してください',
  form_company_placeholder: '会社名を入力してください（任意）',
  form_message_placeholder: 'お問い合わせ内容をご記入ください...',
  form_submit: '今すぐ送信',
  form_sending: '送信中...',
  form_success: '送信完了！できるだけ早くご返信いたします。',
  form_error: '送信に失敗しました。しばらくしてから再度お試しください。',
  form_cancel: 'キャンセル',

  // ===== Footer =====
  footer_company_desc: 'プロフェッショナル電動工具メーカー、50年の業界経験、グローバルに信頼',
  footer_products: '製品',
  footer_support: 'サポート',
  footer_company: '会社について',
  footer_copyright: '全著作権所有',

  maintenance_title: '現在、ウェブサイトはメンテナンス中です。',
  maintenance_subtitle: 'ご不便をおかけして申し訳ございません。',
  maintenance_timestamp: '現在時刻',
  maintenance_contact: '緊急のお問い合わせはこちらからお願いします',

  // ===== Nail Guns Page =====
  nail_guns_hero_title: 'コードレス釘打機シリーズ',
  nail_guns_hero_subtitle: '4V / 20V / ACシリーズをカバーするプロフェッショナルコードレス釘打機',
  nail_guns_hero_desc: 'あらゆる建設シナリオのニーズを満たす',
  nail_guns_page_title: 'コードレス釘打機シリーズ',
  nail_guns_page_desc: '4V / 20V / ACシリーズをカバーするプロフェッショナルコードレス釘打機、あらゆる建設シナリオのニーズを満たす',
  nail_guns_products_count: '製品',
  brushless_products_count: '製品',
  workshop_products_count: '製品',
  sharpening_products_count: '製品',

  // ===== Garden Tools Page =====
  garden_tools_hero_title: 'ガーデンツールシリーズ',
  garden_tools_hero_subtitle: 'チェーンソー、高枝鋸、ヘッジトリマーなどを含むプロフェッショナルガーデンツール',
  garden_tools_hero_desc: 'あらゆるガーデン作業のニーズを満たす',
  garden_tools_page_title: 'ガーデンツールシリーズ',
  garden_tools_page_desc: 'チェーンソー、高枝鋸、ヘッジトリマーなどを含むプロフェッショナルガーデンツール、あらゆるガーデン作業のニーズを満たす',
  garden_tools_products_count: '製品',

  // ===== Brushless Page =====
  brushless_hero_title: 'ブラシレスコードレスシリーズ',
  brushless_hero_subtitle: 'インパクトドリル、インパクトドライバー、アングルグラインダーシリーズをカバーする高効率ブラシレスモーター技術',
  brushless_hero_desc: '強力で耐久性が高い',
  brushless_page_title: 'ブラシレスコードレスシリーズ',
  brushless_page_desc: 'インパクトドリル、インパクトドライバー、アングルグラインダーシリーズをカバーする高効率ブラシレスモーター技術、強力で耐久性が高い',

  // ===== Workshop Page =====
  workshop_hero_title: 'ワークショップツールシリーズ',
  workshop_hero_subtitle: '自動車仕上げ、木工ワークショップ、修理ワークショップ向けのプロフェッショナルツールシリーズ',
  workshop_hero_desc: 'ポリッシング、サンディング、接着など多様な工程をカバー、効率的なワークショップ作業をサポート',
  workshop_page_title: 'ワークショップツールシリーズ',
  workshop_page_desc: 'プロフェッショナルワークショップ向けにカスタマイズされた高性能ツール、自動車磨きから表面処理、精密接着から素材研磨まで',

  // ===== Sharpening Page =====
  sharpening_hero_title: 'プロフェッショナル研磨シリーズ',
  sharpening_hero_subtitle: '多機能研削ワークベンチ、ドリルビット修理機、彫刻ツールを含むプロフェッショナル研磨・彫刻ツール',
  sharpening_hero_desc: '精密設計、高効率・耐久性、あらゆるプロフェッショナル研削・彫刻ニーズを満たす',
  sharpening_page_title: 'プロフェッショナル研磨シリーズ',
  sharpening_page_desc: '多機能研削ワークベンチから精密ドリルビット修理機、プロフェッショナル彫刻ツールまで包括的な研削・彫刻ソリューション',

  // ===== Nail 4V Features =====
  nail_4v_f15_desc: '4V タッカー',
  nail_4v_f20_desc: '4V タッカー',
  nail_4v_t50_desc: '4V タッカー',
  nail_4v_j64_desc: '4V タッカー',
  nail_4v_u22_desc: '4V タッカー',
  nail_4v_n50_desc: '20V タッカー',
  nail_4v_b18_desc: '20V タッカー',
  nail_4v_c25_desc: '20V タッカー',
  nail_4v_d30_desc: '20V タッカー',
  nail_4v_e40_desc: '20V タッカー',
  nail_20v_f30_desc: '20V タッカー',
  nail_20v_f50_desc: '20V タッカー',
  nail_20v_t64_desc: '20V タッカー',
  nail_20v_j80_desc: '20V タッカー',
  nail_20v_n90_desc: '20V コードレスケーブルタッカー',
  nail_20v_b50_desc: '20V タッカー',
  nail_20v_c60_desc: '20V タッカー',
  nail_20v_d70_desc: 'Dタイプ20Vリチウム釘打機',
  nail_20v_e80_desc: 'Eタイプ20Vリチウム釘打機',
  nail_20v_g100_desc: 'Gタイプ20Vリチウムフラッグシップ釘打機',
  nail_ac_f30_desc: 'AC タッカー',
  nail_ac_f50_desc: 'AC タッカー',
  nail_ac_t64_desc: 'AC タッカー',
  nail_ac_j80_desc: 'AC タッカー',
  nail_ac_n90_desc: 'AC タッカー',
  nail_ac_b50_desc: 'BタイプAC電動釘打機',
  nail_ac_c60_desc: 'CタイプAC電動コイル釘打機',
  nail_ac_d70_desc: 'DタイプAC電動釘打機',
  nail_ac_e80_desc: 'EタイプAC電動釘打機',
  nail_ac_g100_desc: 'GタイプAC電動フラッグシップ釘打機',

  // ===== Brushless Card Descriptions =====
  brushless_drill_card_desc: '20Vブラシレスコードレスインパクトドリル',
  brushless_wrench_card_desc: '20Vブラシレスコードレスインパクトレンチ',
  brushless_driver_card_desc: '20Vブラシレスコードレスインパクトドライバー',
  brushless_grinder_card_desc: '20Vブラシレスコードレスアングルグラインダー',

  // ===== Workshop Nested Keys =====
  'products.workshop.hero.brand': 'LEIMING TOOLS',
  'products.workshop.hero.title': 'ワークショップツールシリーズ',
  'products.workshop.hero.description': 'ポリッシング、サンディング、接着など多様な工程をカバー、効率的なワークショップ作業をサポート',
  'products.workshop.pageHeader.title': 'ワークショップツールシリーズ',
  'products.workshop.pageHeader.description': 'プロフェッショナルワークショップ向けにカスタマイズされた高性能ツール、自動車磨きから表面処理、精密接着から素材研磨まで',
  'products.workshop.categories.polisher': 'カーポリッシャー',
  'products.workshop.categories.sander': 'サンダー＆表面処理',
  'products.workshop.categories.glueGun': 'ホットグルーガン',
  'products.workshop.polisher.001.name': '20V 充電式ダブルアクションポリッシャー',
  'products.workshop.polisher.001.model': 'S0P-DW05-150',
  'products.workshop.polisher.001.description': '20V 充電式ダブルアクションポリッシャー',
  'products.workshop.polisher.002.name': '600W ダブルアクションポリッシャー',
  'products.workshop.polisher.002.model': 'S1P-DW01-180',
  'products.workshop.polisher.002.description': '600W ダブルアクションポリッシャー',
  'products.workshop.polisher.003.name': '125mm ミニカーポリッシャー',
  'products.workshop.polisher.003.model': 'LK-WS-POL-125-MN',
  'products.workshop.polisher.003.description': '125mm ミニカーポリッシャー',
  'products.workshop.polisher.004.name': '200mm 大径カーポリッシャー',
  'products.workshop.polisher.004.model': 'LK-WS-POL-200-LP',
  'products.workshop.polisher.004.description': '200mm 大径カーポリッシャー',
  'products.workshop.polisher.005.name': '180mm 可変速カーポリッシャー',
  'products.workshop.polisher.005.model': 'LK-WS-POL-180-VS',
  'products.workshop.polisher.005.description': '180mm 可変速カーポリッシャー',
  'products.workshop.polisher.006.name': '150mm デュアルモードカーポリッシャー',
  'products.workshop.polisher.006.model': 'LK-WS-POL-150-DM',
  'products.workshop.polisher.006.description': '150mm デュアルモードカーポリッシャー',
  'products.workshop.polisher.007.name': '125mm コードレスカーポリッシャー',
  'products.workshop.polisher.007.model': 'LK-WS-POL-125-CL',
  'products.workshop.polisher.007.description': '125mm コードレスカーポリッシャー',
  'products.workshop.polisher.008.name': '180mm 空気圧カーポリッシャー',
  'products.workshop.polisher.008.model': 'LK-WS-POL-180-PN',
  'products.workshop.polisher.008.description': '180mm 空気圧カーポリッシャー',
  'products.workshop.polisher.009.name': '150mm ウェットカーポリッシャー',
  'products.workshop.polisher.009.model': 'LK-WS-POL-150-WT',
  'products.workshop.polisher.009.description': '150mm ウェットカーポリッシャー',
  'products.workshop.polisher.010.name': '180mm スマートカーポリッシャー',
  'products.workshop.polisher.010.model': 'LK-WS-POL-180-SM',
  'products.workshop.polisher.010.description': '180mm スマートカーポリッシャー',
  'products.workshop.sander.001.name': '125mm 偏心軌道サンダー',
  'products.workshop.sander.001.model': 'LK-WS-SAN-125-EO',
  'products.workshop.sander.001.description': '125mm 偏心軌道サンダー',
  'products.workshop.sander.002.name': '150mm ランダム軌道サンダー',
  'products.workshop.sander.002.model': 'LK-WS-SAN-150-RO',
  'products.workshop.sander.002.description': '150mm ランダム軌道サンダー',
  'products.workshop.sander.003.name': '100mm 三角形ディテールサンダー',
  'products.workshop.sander.003.model': 'LK-WS-SAN-100-DT',
  'products.workshop.sander.003.description': '100mm 三角形ディテールサンダー',
  'products.workshop.sander.004.name': '200mm ワイドベルトサンダー',
  'products.workshop.sander.004.model': 'LK-WS-SAN-200-WB',
  'products.workshop.sander.004.description': '200mm ワイドベルトサンダー',
  'products.workshop.sander.005.name': '125mm 可変速サンダー',
  'products.workshop.sander.005.model': 'LK-WS-SAN-125-VS',
  'products.workshop.sander.005.description': '125mm 可変速サンダー',
  'products.workshop.sander.006.name': '150mm 乾湿両用サンダー',
  'products.workshop.sander.006.model': 'LK-WS-SAN-150-WD',
  'products.workshop.sander.006.description': '150mm 乾湿両用サンダー',
  'products.workshop.sander.007.name': '125mm コードレス軌道サンダー',
  'products.workshop.sander.007.model': 'LK-WS-SAN-125-CL',
  'products.workshop.sander.007.description': '125mm コードレス軌道サンダー',
  'products.workshop.sander.008.name': '100mm 空気圧パームサンダー',
  'products.workshop.sander.008.model': 'LK-WS-SAN-100-PN',
  'products.workshop.sander.008.description': '100mm 空気圧パームサンダー',
  'products.workshop.sander.009.name': '150mm 壁・天井サンダー',
  'products.workshop.sander.009.model': 'LK-WS-SAN-150-WC',
  'products.workshop.sander.009.description': '150mm 壁・天井サンダー',
  'products.workshop.sander.010.name': '125mm 静音軌道サンダー',
  'products.workshop.sander.010.model': 'LK-WS-SAN-125-SL',
  'products.workshop.sander.010.description': '125mm 静音軌道サンダー',
  'products.workshop.glueGun.001.name': '4V リチウムホットグルーガン',
  'products.workshop.glueGun.001.model': 'Q0A-DW02-4V',
  'products.workshop.glueGun.001.description': '4V コードレスグルーガン',
  'products.workshop.glueGun.002.name': '12V リチウムホットグルーガン',
  'products.workshop.glueGun.002.model': 'Q0A-DW02-12V',
  'products.workshop.glueGun.002.description': '12V ホットメルトグルーガン',
  'products.workshop.glueGun.003.name': '20V コードレスグルーガン',
  'products.workshop.glueGun.003.model': 'Q0A-DW06-20V',
  'products.workshop.glueGun.003.description': '20V コードレスグルーガン',
  'products.workshop.glueGun.004.name': '120W デュアル温度ホットグルーガン',
  'products.workshop.glueGun.004.model': 'LK-WS-GLU-120W-DT',
  'products.workshop.glueGun.004.description': '120W デュアル温度ホットグルーガン',
  'products.workshop.glueGun.005.name': '80W コードレスホットグルーガン',
  'products.workshop.glueGun.005.model': 'Q0A-DW02-4V-CL',
  'products.workshop.glueGun.005.description': '80W コードレスホットグルーガン',
  'products.workshop.glueGun.006.name': '100W 精密ホットグルーガン',
  'products.workshop.glueGun.006.model': 'LK-WS-GLU-100W-PR',
  'products.workshop.glueGun.006.description': '100W 精密ホットグルーガン',
  'products.workshop.glueGun.007.name': '150W 工業用ホットグルーガン',
  'products.workshop.glueGun.007.model': 'LK-WS-GLU-150W-IN',
  'products.workshop.glueGun.007.description': '150W 工業用ホットグルーガン',
  'products.workshop.glueGun.008.name': '80W スマートホットグルーガン',
  'products.workshop.glueGun.008.model': 'Q0A-DW02-4V-SM',
  'products.workshop.glueGun.008.description': '80W スマートホットグルーガン',
  'products.workshop.glueGun.009.name': '100W デュアルノズルホットグルーガン',
  'products.workshop.glueGun.009.model': 'LK-WS-GLU-100W-DN',
  'products.workshop.glueGun.009.description': '100W デュアルノズルホットグルーガン',
  'products.workshop.glueGun.010.name': '80W ロングノズルホットグルーガン',
  'products.workshop.glueGun.010.model': 'Q0A-DW02-4V-LN',
  'products.workshop.glueGun.010.description': '80W ロングノズルホットグルーガン',
  // End of translation object

  // ===== カテゴリレベル フィーチャーキー =====

  // 釘打機 4V
  nail_4v_feature_1_title: '0.7kgの超軽量ボディデザイン',
  nail_4v_feature_1_desc: '重さはわずか0.7kgで、ペットボトルよりも軽いため、繊細な作業でも容易に操作できます。',
  nail_4v_feature_2_title: '1000の超長距離射撃範囲',
  nail_4v_feature_2_desc: '1回の充電で1000回発射でき、高い耐久性により頻繁な充電は不要です。',
  nail_4v_feature_3_title: 'あらゆるタイプのネイルに対応',
  nail_4v_feature_3_desc: 'この多機能な3in1ステープラーは、53#、T50#ステープル、および47#/BN1810ストレートステープルに対応しています。',
  nail_4v_feature_4_title: '最適化されたセキュリティと監視',
  nail_4v_feature_4_desc: '二重の安全接点と透明な釘収納窓の組み合わせにより、より安全で集中した作業が可能になります。',
  nail_4v_feature_5_title: '多用途対応',
  nail_4v_feature_5_desc: '室内木工・家具組立・細工など様々な作業シーンに対応',

  // 釘打機 20V
  nail_20v_feature_1_title: '高出力ブラシレスモーター',
  nail_20v_feature_1_desc: '強力なブラシレスモーターで硬木も軽々貫通、安定した打ち込みを実現',
  nail_20v_feature_2_title: '60分急速充電',
  nail_20v_feature_2_desc: '大容量バッテリーが60分で満充電、終日作業も安心',
  nail_20v_feature_3_title: '防塵防震設計',
  nail_20v_feature_3_desc: '過酷な施工環境にも対応する耐久性の高いボディ設計',
  nail_20v_feature_4_title: '大容量マガジン',
  nail_20v_feature_4_desc: '110本入り大容量マガジン、頻繁な補充なしで連続作業が可能',
  nail_20v_feature_5_title: 'プロフェッショナル仕様',
  nail_20v_feature_5_desc: '現場の厳しい要求に応えるプロ仕様の設計と信頼性',

  // 釘打機 AC
  nail_ac_feature_1_title: '途切れない連続作業',
  nail_ac_feature_1_desc: 'AC電源直結で電池切れの心配なく高強度連続作業が可能',
  nail_ac_feature_2_title: '800W強力出力',
  nail_ac_feature_2_desc: '毎秒最大1.5本の高速打ち込み、大規模施工の効率を大幅向上',
  nail_ac_feature_3_title: '安定した打ち込み力',
  nail_ac_feature_3_desc: '一定の電源供給により常に安定した打ち込み力を発揮',
  nail_ac_feature_4_title: '安全滑り止め設計',
  nail_ac_feature_4_desc: '安定した底面設計であらゆる作業台面での安全操作を保証',
  nail_ac_feature_5_title: '耐久性ボディ',
  nail_ac_feature_5_desc: '高品質合金素材で長期使用に耐える優れた耐久性を実現',

  // ブラシレス インパクトドリル
  brushless_drill_feature_1_title: '高性能ブラシレスモーター',
  brushless_drill_feature_1_desc: '最大80N·mのトルクで様々な穿孔・締付け作業に対応',
  brushless_drill_feature_2_title: '2速クラッチ設定',
  brushless_drill_feature_2_desc: '柔軟なモード切替で力加減の調節が可能',
  brushless_drill_feature_3_title: 'LED内蔵照明',
  brushless_drill_feature_3_desc: '内蔵LEDライトが暗い場所での作業を快適にサポート',
  brushless_drill_feature_4_title: 'クイックロックチャック',
  brushless_drill_feature_4_desc: 'ツールフリーで素早くビット交換、作業効率を向上',
  brushless_drill_feature_5_title: '全金属ギアボックス',
  brushless_drill_feature_5_desc: '精密設計の全金属ギアボックスで高い伝達効率と長期耐久性を保証',

  // ブラシレス インパクトドライバー
  brushless_driver_feature_1_title: '最大180N·mインパクトトルク',
  brushless_driver_feature_1_desc: '強力なインパクト機構でボルトの締付けと緩めを高効率化',
  brushless_driver_feature_2_title: 'コンパクト軽量設計',
  brushless_driver_feature_2_desc: '重量わずか1.3kg、狭いスペースへのアクセスも楽にこなせる',
  brushless_driver_feature_3_title: '4速モード切替',
  brushless_driver_feature_3_desc: '4段階の速度設定で様々な作業シーンに精確に対応',
  brushless_driver_feature_4_title: '3点式LED照明',
  brushless_driver_feature_4_desc: '3方向LED照明が全角度から影をなくし視界を確保',
  brushless_driver_feature_5_title: 'クイックリリース六角チャック',
  brushless_driver_feature_5_desc: '素早くビットを交換できる六角チャック、設置効率を大幅向上',

  // ブラシレス アングルグラインダー
  brushless_grinder_feature_1_title: '高速8500RPM',
  brushless_grinder_feature_1_desc: 'プロフェッショナルな切断と研削に対応した強力な回転数を実現',
  brushless_grinder_feature_2_title: 'スマート過負荷保護',
  brushless_grinder_feature_2_desc: 'インテリジェント電子保護システムがモーターを自動保護',
  brushless_grinder_feature_3_title: 'ソフトスタート機能',
  brushless_grinder_feature_3_desc: '起動時のキックバックを防止し安全な操作を保障',
  brushless_grinder_feature_4_title: 'ツールフリーディスク交換',
  brushless_grinder_feature_4_desc: 'クイックリリースシステムで工具なしに瞬時にディスク交換',
  brushless_grinder_feature_5_title: '多工況対応',
  brushless_grinder_feature_5_desc: '金属切断・溶接清掃・表面研削など幅広い用途に対応',

  // 園林 チェーンソー
  garden_chainsaw_feature_1_title: '高品質合金鋼チェーン',
  garden_chainsaw_feature_1_desc: 'チェーン速度10m/sで木材を効率的に切断、断面が整然と滑らか',
  garden_chainsaw_feature_2_title: '自動潤滑システム',
  garden_chainsaw_feature_2_desc: '内蔵自動給油機構でチェーンに持続的に潤滑、メンテナンスを軽減',
  garden_chainsaw_feature_3_title: 'ツールフリーバー交換',
  garden_chainsaw_feature_3_desc: 'クイックリリース機構でガイドバーの素早い取り外し・取り付けが可能',
  garden_chainsaw_feature_4_title: '安全チェーンブレーキ',
  garden_chainsaw_feature_4_desc: '瞬時応答の安全ブレーキが作業中の不意の事故を防止',
  garden_chainsaw_feature_5_title: '低振動人間工学設計',
  garden_chainsaw_feature_5_desc: '防振設計と人間工学的なグリップで長時間作業の疲労を軽減',

  // 園林 高枝鋸
  garden_pole_feature_1_title: '最大3m伸縮ポール',
  garden_pole_feature_1_desc: 'はしごなしで最大5mの高さに届きます。鋸ヘッドが0-60°の多角度調整に対応し、軽量の3.2kgポールが頭上作業の腕の疲れを最小化します。内蔵過負荷自動保護が信頼性の高い安全性を確保し、果樹園管理と街路樹剪定のプロ向けツールです。',
  garden_pole_feature_2_title: '0-60°多角度調整',
  garden_pole_feature_2_desc: '鋸ヘッドが多角度に調整可能、あらゆる枝の角度に対応',
  garden_pole_feature_3_title: '軽量設計3.2kg',
  garden_pole_feature_3_desc: '超軽量ポール素材で重量を抑えた設計。頭上作業時の腕の疲れを最小化します。',
  garden_pole_feature_4_title: '過負荷自動保護',
  garden_pole_feature_4_desc: '内蔵保護機構が過負荷時に自動停止してモーターを保護',
  garden_pole_feature_5_title: 'プロ向け設計',
  garden_pole_feature_5_desc: '果樹園管理と街路樹剪定のプロに最適化された設計',

  // 園林 芝管理
  garden_lawn_feature_1_title: 'ワイド作業ヘッド',
  garden_lawn_feature_1_desc: '広い作業幅で1回のパスでより広い面積をカバー、作業時間を短縮',
  garden_lawn_feature_2_title: '折りたたみ収納',
  garden_lawn_feature_2_desc: 'コンパクト折りたたみ設計で収納スペースを大幅節約',
  garden_lawn_feature_3_title: '多段階高さ調整',
  garden_lawn_feature_3_desc: '複数段階の高さ調整で様々な身長のユーザーに対応',
  garden_lawn_feature_4_title: '低騒音設計',
  garden_lawn_feature_4_desc: '78dB未満の静音運転で住宅地での作業に最適。振動も低減され長時間作業の疲労を軽減します。',
  garden_lawn_feature_5_title: 'コードレス自由設計',
  garden_lawn_feature_5_desc: '20Vリチウムバッテリーで電源コードの制約なく広い庭を自由に作業',

  // 工坊 ポリッシャー
  workshop_polisher_feature_1_title: '特許デュアルアクション機構',
  workshop_polisher_feature_1_desc: '均一で繊細な研磨動作で旋傷を効果的に防止し美しい仕上がりを実現',
  workshop_polisher_feature_2_title: '6段階速度制御',
  workshop_polisher_feature_2_desc: '粗研磨からミラー仕上げまで全工程をカバーする精密な速度設定',
  workshop_polisher_feature_3_title: '誰でもプロの仕上がり',
  workshop_polisher_feature_3_desc: '直感的な操作設計で初心者でもプロ級の研磨結果を実現',
  workshop_polisher_feature_4_title: 'マジックテープ式パッド',
  workshop_polisher_feature_4_desc: '素早いパッド交換で研磨工程の切り替えをスピーディーに',
  workshop_polisher_feature_5_title: '人間工学グリップ',
  workshop_polisher_feature_5_desc: '快適な握り感で長時間の研磨作業でも疲れにくい設計',

  // 工坊 サンダー
  workshop_sander_feature_1_title: '精密偏心軌道設計',
  workshop_sander_feature_1_desc: '均一でプロフェッショナルな表面仕上げを実現する精密軌道技術',
  workshop_sander_feature_2_title: '高効率集塵システム',
  workshop_sander_feature_2_desc: '内蔵集塵機構が研削粉塵を効率的に捕集し作業環境を清潔に保つ',
  workshop_sander_feature_3_title: 'ワンタッチディスク交換',
  workshop_sander_feature_3_desc: 'マジックテープ式でツール不要に瞬時に目の粗さを変更',
  workshop_sander_feature_4_title: '防振ハンドル',
  workshop_sander_feature_4_desc: '長時間使用でも疲れにくい防振設計で快適な作業をサポート',
  workshop_sander_feature_5_title: '多用途対応',
  workshop_sander_feature_5_desc: '木工精加工・塗料剥離・金属磨きなど幅広い表面処理作業に対応',

  // 工坊 グルーガン
  workshop_glue_feature_1_title: '60秒急速昇温',
  workshop_glue_feature_1_desc: 'わずか60秒で作業温度に達し、迅速に接着作業を開始できる',
  workshop_glue_feature_2_title: '滴り防止設計',
  workshop_glue_feature_2_desc: '特許取得の逆流防止機構でトリガーを離すと即座に流れが止まる',
  workshop_glue_feature_3_title: '過熱保護機能',
  workshop_glue_feature_3_desc: '内蔵過熱保護センサーが常時監視して安全な使用を確保',
  workshop_glue_feature_4_title: '幅広い用途',
  workshop_glue_feature_4_desc: '模型製作・クラフト・家具修復・包装など多様な接着シーンに対応',
  workshop_glue_feature_5_title: '快適グリップ設計',
  workshop_glue_feature_5_desc: '人間工学に基づいたグリップで長時間の細かい接着作業も快適',

  // 磨刀 ワークベンチ
  sharpening_workbench_feature_1_title: '精密角度ガイド',
  sharpening_workbench_feature_1_desc: '0-45°無段階調整対応の精密角度ガイドレールを搭載。毎回一貫した正確な研削角度を保証',
  sharpening_workbench_feature_2_title: '恒速研削モーター',
  sharpening_workbench_feature_2_desc: '安定した回転数が平坦で均一な研削面を実現',
  sharpening_workbench_feature_3_title: '水冷冷却システム',
  sharpening_workbench_feature_3_desc: '持続冷却で研削中の熱による刃の変質・損傷を防止',
  sharpening_workbench_feature_4_title: '多機能対応',
  sharpening_workbench_feature_4_desc: '包丁・大工道具・ガーデン工具など様々な刃物の研削に対応',
  sharpening_workbench_feature_5_title: 'プロ向け精度',
  sharpening_workbench_feature_5_desc: 'プロシェフと木工師傅が求める研磨精度と仕上がり品質を実現',

  // 磨刀 ドリル修復機
  sharpening_drill_feature_1_title: 'スマート自動位置決め',
  sharpening_drill_feature_1_desc: '自動角度識別システムで手動調整なしで最適な研削角度を設定',
  sharpening_drill_feature_2_title: 'ワイド対応サイズ',
  sharpening_drill_feature_2_desc: '3-13mmの全ての直柄ドリルビットに対応可能',
  sharpening_drill_feature_3_title: '高精度三爪チャック',
  sharpening_drill_feature_3_desc: '自動調心機能付きチャックで優れた同軸精度を確保',
  sharpening_drill_feature_4_title: '簡単操作設計',
  sharpening_drill_feature_4_desc: '直感的な操作で5分以内に習熟でき初心者でも扱いやすい',
  sharpening_drill_feature_5_title: '業務用対応',
  sharpening_drill_feature_5_desc: '工場での一括修理から個人のメンテナンスまで幅広く活用可能',

  // 磨刀 彫刻ツール
  sharpening_engraving_feature_1_title: '30,000RPM高速回転',
  sharpening_engraving_feature_1_desc: '超高速回転で滑らかな彫刻面と卓越したディテール表現力を実現',
  sharpening_engraving_feature_2_title: '無段階速度制御',
  sharpening_engraving_feature_2_desc: 'ゆっくりとした精密トレースから高速彫刻まで自由に速度を調整',
  sharpening_engraving_feature_3_title: 'スリムペングリップ',
  sharpening_engraving_feature_3_desc: '自然な握り感のペン型デザインで長時間の精密彫刻も疲れにくい',
  sharpening_engraving_feature_4_title: '多素材対応',
  sharpening_engraving_feature_4_desc: '木材・金属・ガラス・セラミックなど幅広い素材への彫刻に対応',
  sharpening_engraving_feature_5_title: '豊富なアタッチメント',
  sharpening_engraving_feature_5_desc: '多様な彫刻刃が付属し、様々な彫刻スタイルと需要に対応',

  // ===== 個別製品説明キー (150款) =====

  // 釘打機 4V (10款)
  product_J_120_description: 'J-120 シリーズは、DIY愛好家にとって理想的な相棒です。わずか0.9kgの軽量ボディにパワフルなモーターを搭載し、毎分60発の発射速度と1000発のバッテリー寿命でプロ並みの性能を発揮します。様々な釘に対応し、便利な充電システムを備えているため、現代のホームツールボックスに欠かせない携帯用ツールです。',
  product_J_125_description: 'J-125 シリーズは、携帯工具の「使い心地」を再定義します。わずか0.7kgの軽量ボディながら、毎分60発の高速連射を実現。塗装、家具修理、装飾など、あらゆる用途に対応し、1000発の連続発射能力とプロ仕様の精度で、携帯性と性能の完璧なバランスを実現し、現代の家庭に最適です。',
  product_J_139_description: 'J-139 シリーズは、DIY愛好家にとって理想的な相棒です。わずか0.9kgの軽量ボディにパワフルなモーターを搭載し、毎分60発の発射速度と1000発のバッテリー寿命でプロ並みの性能を発揮します。様々な釘に対応し、便利な充電システムを備えているため、現代のホームツールボックスに欠かせない携帯用ツールです。',
  product_J_126_description: 'J-126 シリーズは、携帯工具の「使い心地」を再定義します。わずか0.7kgの軽量ボディながら、毎分60発の高速連射を実現。塗装、家具修理、装飾など、あらゆる用途に対応し、1000発の連続発射能力とプロ仕様の精度で、携帯性と性能の完璧なバランスを実現し、現代の家庭に最適です。',
  product_J_153_description: 'J-153はU型ステープル専用の4Vコードレスガンです。網・電線・断熱材の固定に最適。連続打ちモードで施工スピードを大幅向上できます。',
  product_lk_4v_n50_description: 'LK-4V-N50はN型コイル釘対応の4Vコードレス釘打機です。ウッドデッキや外壁木材の固定に最適。大容量マガジンで補充頻度を減らし作業効率を向上します。',
  product_lk_4v_b18_description: 'LK-4V-B18はB型ブラッド釘専用の精密釘打機です。キャビネットや家具の細部仕上げに最適な一台。ノーマーク技術で木材表面を傷つけずに施工できます。',
  product_lk_4v_c25_description: 'LK-4V-C25はC型コイル釘対応のミニコードレス釘打機です。軽量枠材や内装工事全般に対応。コンパクトボディながら高い打ち込み精度を実現しています。',
  product_lk_4v_d30_description: 'LK-4V-D30はD型釘専用の4Vリチウム釘打機です。室内造作工事や木工クラフトに最適。エルゴノミクス設計のグリップで長時間作業でも疲れにくい設計です。',
  product_lk_4v_e40_description: 'LK-4V-E40はE型釘対応のマルチパーパス4Vコードレス釘打機です。様々な厚みの木材に対応し、DIYから本格的な木工作業まで幅広く使用できます。',

  // 釘打機 20V (10款)
  product_J_128_description: 'J-128 シリーズは、携帯型締結工具の概念を覆します。この20V工具は、頑丈な釘打ち機と精密なストレート釘打ち機の機能を、わずか1.35kgのボディに統合しています。住宅配線、屋根工事、家具の補修など、あらゆる作業において、毎分100発の発射速度と堅牢な金属製マガジンにより、プロ仕様の信頼性の高い使用感を提供します。',
  product_J_129_description: 'J-129 シリーズは、携帯型締結工具の概念を覆します。この20V工具は、頑丈な釘打ち機と精密なストレート釘打ち機の機能を、わずか1.35kgのボディに統合しています。住宅配線、屋根工事、家具の補修など、あらゆる作業において、毎分100発の発射速度と堅牢な金属製マガジンにより、プロ仕様の信頼性の高い使用感を提供します。',
  product_J_133_description: 'エアポンプやホースの制約とはもうお別れです。J-133 20V電動釘打ち機はわずか1.9kgと軽量で、作業負担を大幅に軽減します。人間工学に基づいた設計と毎分60発の発射速度により、様々な作業シーンで半分の労力で2倍の成果を上げることができ、携帯性と工業グレードの性能を完璧に両立させています。',
  product_J_145_description: 'J-145 シリーズは、携帯型締結工具の概念を覆します。この20V工具は、頑丈な釘打ち機と精密なストレート釘打ち機の機能を、わずか1.35kgのボディに統合しています。住宅配線、屋根工事、家具の補修など、あらゆる作業において、毎分100発の発射速度と堅牢な金属製マガジンにより、プロ仕様の信頼性の高い使用感を提供します。',
  product_J_147_description: 'J-147 20Vケーブルクランプガンは、ケーブル固定に従来使用されていたハンマーに代わるプロ仕様のソリューションです。20Vの高電圧と19.5mmケーブルクランプ専用に設計された機構を組み合わせ、毎分20回の高速動作とLED照明により、安定した安全な作業を実現。複雑なケーブル配線作業を最大3倍のスピードで完了できます。',
  product_J_150_description: 'J-150 20Vブラシレス釘打ち機は、従来の電動釘打ち機にありがちな電源供給の遅延を完全に解消します。内蔵の圧縮窒素システムにより瞬時に強力なパワーを発揮し、様々な種類の硬材に正確に釘を打ち込むことができます。プロユーザー向けに設計されたこの釘打ち機は、軽量2.9kgのバランスを保ちながらLED作業灯を搭載し、ホースの制約を受けない携帯性と工業グレードの耐久性を実現しています。',
  product_J_156_description: 'エアポンプやホースの制約とはもうお別れです。J-156 20V電動釘打ち機はわずか1.9kgと軽量で、作業負担を大幅に軽減します。人間工学に基づいた設計と毎分60発の発射速度により、様々な作業シーンで半分の労力で2倍の成果を上げることができ、携帯性と工業グレードの性能を完璧に両立させています。',
  product_lk_20v_d70_description: 'LK-20V-D70はD型釘70mm対応の20Vリチウム釘打機です。梱包材料・パレット・合板の固定に最適。大型マガジンと急速充電で生産ラインの効率を高めます。',
  product_lk_20v_e80_description: 'LK-20V-E80はE型釘80mm対応の20V多機能コードレス釘打機です。フローリング・デッキ・フェンス施工に威力を発揮。防塵防水設計で屋外施工にも対応します。',
  product_lk_20v_g100_description: 'LK-20V-G100は20Vフラッグシップモデルの最高峰釘打機です。G型プロ釘100mm対応で最大施工能力を実現。スマート診断機能搭載でメンテナンス時期を自動通知します。',

  // 釘打機 AC (10款)
  product_J_112_description: 'J-112電動釘打ち機は、プロ仕様の選択肢です。プラグイン式なのでバッテリー寿命の制限がなく、ドアや窓枠、キャビネット、幅木などの取り付けに最適です。毎分30発の安定した発射速度と2in1互換性により、住宅および商業施設の仕上げ作業において効率的で信頼性の高い性能を発揮します。',
  product_J_115_description: 'J-115 シリーズは、軽量性と信頼性のバランスを求めるユーザー向けに設計されています。わずか0.6kgの超軽量ボディに、連続作動パワーを搭載。家具の補修から繊細な手作業まで、毎分30回の打撃頻度とマルチネイル対応により、プロ仕様の精度を実現。まさに現代の理想的なツールです。',
  product_J_118_description: 'J-118 シリーズは、軽量性と信頼性のバランスを求めるユーザー向けに設計されています。わずか0.6kgの超軽量ボディに、連続作動パワーを搭載。家具の補修から繊細な手作業まで、毎分30回の打撃頻度とマルチネイル対応により、プロ仕様の精度を実現。まさに現代の理想的なツールです。',
  product_J_119_description: 'J-119 シリーズは、軽量性と信頼性のバランスを求めるユーザー向けに設計されています。わずか0.6kgの超軽量ボディに、連続作動パワーを搭載。家具の補修から繊細な手作業まで、毎分30回の打撃頻度とマルチネイル対応により、プロ仕様の精度を実現。まさに現代の理想的なツールです。',
  product_J_123_description: 'J-123 電動コンパクト釘打ち機は、住宅改修の概念を覆します。わずか0.71kgの軽量設計で、プロ並みの仕上がりを求めるユーザーに最適です。家具のリフォームからホリデーシーズンの飾り付けまで、毎分30発の連射速度と安定したパワーで、正確な打ち込みを実現します。狭い場所にも届き、硬い素材にも対応できるため、あらゆるタイプのスタジオに最適です。',
  product_lk_ac_b50_description: 'LK-AC-B50はB型ブラッド釘対応のAC精密釘打機です。高品質な内装仕上げ施工に最適。クロスライン深さ制御で高品質な仕上がりを実現します。',
  product_lk_ac_c60_description: 'LK-AC-C60はC型コイル釘対応の20V高効率釘打機です。内装板や軽量鉄骨の固定施工に最適。エルゴノミクス設計で長時間作業でも疲れにくい設計です。',
  product_lk_ac_d70_description: 'LK-AC-D70はD型釘70mm対応のAC産業用釘打機です。大型生産ラインでの効率的な固定に最適。高耐久ボディで24時間連続稼働にも対応できます。',
  product_lk_ac_e80_description: 'LK-AC-E80はE型釘80mm対応のACデッキ専用釘打機です。屋外ウッドデッキや木製フェンスの施工に最適。ステンレス内部機構で湿気の多い屋外環境でも錆びにくい設計です。',
  product_lk_ac_g100_description: 'LK-AC-G100はACフラッグシップモデルの最高峰釘打機です。G型プロ釘100mm対応で最大1200Wの強力出力を実現。プロ施工現場の最高性能を追求したモデルです。',

  // ブラシレス ドリル・レンチ (drill-001, id-001~009)
  product_drill_001_description: 'P0L-DW01-4V 家具の組み立てや精密な修理に最適な頼れるパートナーです。4.5Nm の安定したトルク出力に加え、革新的な 180° 回転式ハンドル設計を採用。ワンタッチでピストル型とストレート型を切り替えられ、あらゆる狭い場所や死角にも対応可能です。本体重量はわずか 0.38kg。便利な USB Type-C 急速充電ポートと LED ワークライトを搭載し、暗所や収納の隅での作業でも、軽快でスマートな操作体験を提供します。',
  product_id_001_description: 'LK-BL-ID-20V-001はコンパクトブラシレスインパクトドリルです。軽量設計で取り回しが楽、日常的なDIYからプロ施工まで幅広く活用できます。クイックチャックで素早いビット交換が可能です。',
  product_id_002_description: 'P0L-DW02-4V は、効率的な作業のために設計されたストレート型ドライバーです。300rpm の高速回転とわずか 0.26kg の軽量ボディを実現。USB Type-C 急速充電とバッテリー残量表示を搭載し、長時間のプロフェッショナルな修理作業でも、正確かつ軽快な操作感を提供します。',
  product_id_003_description: 'J0Z-DW07-13 は、重負荷の工事や高強度のタスク向けに設計されたブラシレスインパクトドリルです。1.45kg のバランスの取れたボディに 100Nm の超強力トルクを秘め、13mm 全金属チャックと3モードインパクトシステムにより、コンクリートへの穴あけや大径ボルトの締め付けにおいて、比類なきパワーと耐久性を発揮します。',
  product_id_004_description: 'J0Z-DW08A-10 シリーズは、軽量設計とプロ仕様の性能を兼ね備えたブラシレスインパクトドリルです。わずか 0.79kg のコンパクトなボディに 40Nm の強力なパワーを秘め、2速金属製インパクトギアボックスと 10mm キーレス金属チャックにより、家庭の修理からプロの現場まで、安定かつ精密で効率的な作業体験を提供します。',
  product_id_005_description: 'J0Z-DW09-13 は、高トルクと優れた携帯性を兼ね備えたプロ仕様のブラシレスインパクトドリルです。0.85kgの軽量ボディで60Nmの強力なパワーを発揮。13mmの大型全金属チャックと3モード切替システムにより、金属、木材、軽質石材への穴あけ作業において、極めて安定した効率的な性能を提供します。',
  product_id_006_description: 'P0L-DW08-12V シリーズは、軽量設計とプロ仕様の性能を兼ね備えたブラシレスインパクトドリルです。わずか 0.79kg のコンパクトなボディに 40Nm の強力なパワーを秘め、2速金属製インパクトギアボックスと 10mm キーレス金属チャックにより、家庭の修理からプロの現場まで、安定かつ精密で効率的な作業体験を提供します。',
  product_id_007_description: 'LK-BL-MD-20V-007はミックスドライブブラシレスドリルです。穿孔・締付け・研磨の多機能対応モデル。作業に応じてモードを切り替えられる万能ツールです。',
  product_id_008_description: 'LK-BL-CD-20V-008はコードレスドリルのコンパクトプレミアムモデルです。小型ながら最大70N·mのトルクを実現。天井工事や照明設置など上向き作業でも楽に扱えます。',
  product_id_009_description: 'LK-BL-MX-20V-009はスマートブラシレスインパクトドリルです。Bluetooth接続で作業データをモニタリング可能。トルク・速度・バッテリー残量をリアルタイムで確認できます。',

  // ブラシレス インパクトドライバー (idr-001~010)
  product_idr_001_description: 'P0L-DW05-12V は、究極の効率を追求して設計された 12V ブラシレスインパクトドライバーです。0.79kg の超軽量ボディに 160Nm という驚異的なトルクを凝縮。3段階のインテリジェント速度制御とクイック装着チャックの組み合わせにより、プロの木工作業から日常の設備メンテナンスまで、比類なき締め付け力と軽快な操作感を提供します。',
  product_idr_002_description: 'P0L-DW07-20V は、優れた性能を誇るインパクトドライバーです。0.79kg の軽量設計ながら 150Nm の高トルク出力を実現。信頼性の高いパワーシステムとクイック装着チャックの組み合わせにより、プロの現場から DIY まで、素早い締め付け作業に最適な一台です。',
  product_idr_003_description: 'P0L-DW04M-280 は、シリーズのフラッグシップモデルであり、驚異の 280Nm のパワーと 1.2kg の軽量ボディを完璧に融合させています。3段階のインテリジェント速度制御と工業用ブラシレス技術により、大規模な木造建築から金属フレームの組み立てまで、あらゆる重負荷の課題を容易に解決します。',
  product_idr_004_description: 'P0B-DW02BL-500 は、プロの技術者のために設計された重負荷対応ブラシレスインパクトレンチです。1.2kg のコンパクトなボディに 500Nm の強力なパワーを凝縮。インテリジェントな反転オートストップ機能と 1/2" 工業グレードチャックにより、大型鋼構造物の組み立てからタイヤ交換まで、安定した安全かつ効率的な性能を提供しま',
  product_idr_005_description: 'P0B-DW03BL-800 は、重負荷作業の基準を再定義するブラシレスインパクトレンチです。850Nm の圧倒的なパワーとインテリジェントな反転オートストップ技術を 1.9kg のボディに凝縮。効率と安全性を両立し、大型鋼構造物、自動車産業、鉱山機械のメンテナンスにおいて、強力な武器となります。',
  product_idr_006_description: 'LK-BL-IDR-20V-006はプロフェッショナル仕様のブラシレスインパクトドライバーです。電子トルク管理機能搭載で締付けトルクの過不足を自動調整。精密施工向けモデルです。',
  product_idr_007_description: 'LK-BL-IDR-20V-007は軽量ブラシレスインパクトドライバーです。重量わずか1.1kgの超軽量設計で頭上作業でも腕が疲れにくい。長時間の細部施工に最適です。',
  product_idr_008_description: 'LK-BL-IDR-20V-008はスマートブラシレスインパクトドライバーです。電子制御クラッチが締付け完了を自動感知して停止。ネジ頭の潰れを防ぐ精密締付けが可能です。',
  product_idr_009_description: 'LK-BL-IDR-20V-009は直角ヘッドブラシレスインパクトドライバーです。狭い配管スペースや壁際での直角締付けに特化。電気・配管工事で頼りになるモデルです。',
  product_idr_010_description: 'LK-BL-IDR-20V-010はフラッグシップブラシレスインパクトドライバーです。最大250N·mトルクとスマートブルートゥース制御を搭載。プロ施工の最高水準を実現するモデルです。',

  // ブラシレス アングルグラインダー (ag-001~010)
  product_ag_001_description: '100mmブラシレスコードレスアングルグラインダーです。金属切断・表面研削・溶接スパッタ清掃に最適なコンパクトモデル。片手でも扱いやすい軽量設計です。',
  product_ag_002_description: '125mmブラシレスコードレスアングルグラインダーのスタンダードモデルです。多目的切断ディスクに対応し様々な素材への切断・研削作業に活躍します。',
  product_ag_003_description: '150mmブラシレスコードレスアングルグラインダーの大径モデルです。広い切断面積で素材の加工スピードを向上。重作業向けのパワフルなモデルです。',
  product_ag_004_description: '125mm可変速ブラシレスアングルグラインダーです。低速から高速まで5段階の速度設定で素材に合わせた最適な速度での加工が可能です。',
  product_ag_005_description: '125mmプレミアムブラシレスアングルグラインダーです。電子ソフトスタートとキックバック保護機能を搭載した安全性重視のプロ向けモデルです。',
  product_ag_006_description: '125mm静音設計ブラシレスアングルグラインダーです。ノイズ低減技術搭載で住宅地での作業も安心。振動も低減され長時間作業の疲労を軽減します。',
  product_ag_007_description: '100mmコンパクトブラシレスアングルグラインダーです。小型軽量設計で狭い場所やコーナー部分の研削に最適。片手操作でも安定した作業が可能です。',
  product_ag_008_description: '125mmマルチ機能ブラシレスアングルグラインダーです。切断・研削・ポリッシングの三役をこなすオールインワンモデル。各種アタッチメントに対応します。',
  product_ag_009_description: '125mmスマートブラシレスアングルグラインダーです。電子負荷感知機能が作業負荷に応じて自動的に出力を調整。安定した加工品質を実現します。',
  product_ag_010_description: '125mmフラッグシップブラシレスアングルグラインダーです。最大出力1200W相当のブラシレスモーターとスマート制御システムを搭載した最高峰モデルです。',

  // 園林 チェーンソー (ht-001~010)
  product_ht_001_description: 'M0L-DW03-5C は、究極の軽量化と強力なパワーを完璧に融合させました。わずか1.32kgの軽量ボディに8m/sの高速モーターを搭載し、果樹園の剪定や庭園のメンテナンスに最適です。優れた人間工学に基づいたハンドルにより、抜群の片手操作感を実現し、狭い場所でも自由自在に作業が行えます。',
  product_ht_002_description: 'M0L-DW03-6C は、軽快な操作性と切断効率の黄金バランスを実現しました。160mmにアップグレードされたガイドバーにより作業範囲が広がり、中径の枝払い作業にも余裕で対応します。1.43kgのボディは携帯性を維持しつつ、安定した持続的なパワーを提供します。',
  product_ht_003_description: 'M0L-DW05-10C は、手持ち式チェンソーの性能の限界を再定義します。10m/sの強力なチェンスピードと270mlの超大容量タンクにより、重作業用エンジン式に匹敵する作業体験を提供します。大規模な伐採や整地向けに設計され、両手持ちの安定した構造が高負荷作業時でも抜群の安定感と安全性を保証します。',
  product_ht_004_description: 'M0L-DW06-8C は、強力な瞬発力を秘めた「ハイパフォーマンス・ツール」です。1.7kgの軽量設計ながら、190mmのロングガイドバーとインテリジェント自動給油システムを統合。高負荷な切断作業中もチェンの潤滑状態を最適に保ち、パワーと携帯性を究極の形で両立させました。',
  product_ht_005_description: '20Vミニリチウムチェーンソーです。コンパクトな6インチガイドバーで果樹の細枝剪定や庭での軽作業に最適。女性でも扱いやすい軽量設計です。',
  product_ht_006_description: '20Vポールチェーンソーです。伸縮ポールが最大4mまで延長でき、はしごなしで高い枝にはしごなしで安全に届きます。多段階高さ調整で様々な枝の角度に対応します。',
  product_ht_007_description: '20Vリチウム電動ヘッジトリマーです。500mmの長いブレードで大きな生け垣の刈り込みを効率的に実施。二重刃設計で滑らかな切断面を実現します。',
  product_ht_008_description: '40Vブラシレス大型チェーンソーです。プロ向けの最大出力モデル。450mmガイドバーと高速チェーン速度で林業・大型伐採作業にも対応します。',
  product_ht_009_description: '20V伸縮修枝鋸です。200mm鋸ヘッドとテレスコープハンドル搭載で2.5mまでの高い枝に届きます。ヘッドの角度調節で様々な枝の向きに対応します。',
  product_ht_010_description: '20Vプロフェッショナル修枝鋸です。プロ造園業者向けの高耐久モデル。強化チェーン設計と大容量バッテリーで長時間の専業剪定作業をサポートします。',

  // 園林 高枝鋸 (pp-001~010)
  product_pp_001_description: 'N0HX-DW01B-410 は、高所作業における重い脚立や安全上のリスクを排除します。全長約3mの作業半径と11段階の可動式ヘッドにより、全方位の剪定視野と角度を提供します。410mmの高品質合金ブレードが正確で滑らかなカットを保証し、高所や複雑な形状の生垣を手入れするためのプロフェッショナルなツールです。',
  product_pp_002_description: 'N0HC-DW01-32 は、密集した樹冠の中の枯れ枝を処理するための「外科用メス」です。32mmの強力な切断能力と5段階のマルチ角度調整システムにより、入り組んだ枝の奥深くにある課題も解決します。アルミ合金製の軽量ロングポール設計により、肩や首への負担を大幅に軽減します。',
  product_pp_003_description: 'M0HL-DW08-8C は、高所での重作業用クリーニングにおける究極のソリューションです。200mmの切断能力を2.7mの伸縮ポールに搭載し、遠距離からの太い材木の除去に特化しています。80mlの自動給油タンクと強化されたダブルハンドルにより、最大伸長時でも安定した切り込みを実現します。',
  product_pp_004_description: '20V軽量コードレス高枝鋸です。アルミ製ポールで重量をわずか2.8kgに抑えた設計。長時間の頭上作業でも疲れにくい設計が特徴です。',
  product_pp_005_description: '20V重作業用コードレス高枝鋸です。太い枝の切断に対応した強力モデル。200mmガイドバーと高チェーン速度で直径80mm以上の太い枝にも対応します。',
  product_pp_006_description: '20V折りたたみ収納高枝鋸です。ポールを折りたたんでコンパクトに収納できる設計。車への積み込みや保管スペースの節約に優れたモデルです。',
  product_pp_007_description: '20Vプロフェッショナルコードレス高枝鋸です。造園業者向けの高耐久・高性能モデル。連続作業に対応した大容量バッテリーと強力なモーターを搭載しています。',
  product_pp_008_description: '20Vスマートコードレス高枝鋸です。電子負荷検知機能が枝の太さに応じて自動的に出力を調整。詰まりを防ぎながら効率的な切断を実現します。',
  product_pp_009_description: '20V人間工学設計コードレス高枝鋸です。グリップとポールの重量バランスを最適化した疲れにくい設計。長時間の庭木管理作業に最適なモデルです。',
  product_pp_010_description: '20V多機能コードレス高枝鋸です。チェーンソーヘッドとヘッジトリマーヘッドの2種類のアタッチメントに対応。一台で多種の高所剪定作業をカバーします。',

  // 園林 芝管理 (lc-001~010)
  product_lc_001_description: 'S1L-DW03-104 は、ツールを常に最高の状態に保つためのメンテナンスの基盤です。5000rpmの高速モーターと左右35°の精密な角度調整により、すべてのチェンコマを新品のような切れ味に蘇らせます。内蔵LED照明が死角をなくし、再起動防止機能が作業中の確かな安全を保証します。',
  product_lc_002_description: 'S0L-DW04-108 は、メンテナンスのスピードを追求するプロの現場のために誕生しました。回転数は6500/minに達し、わずか1.65kgの軽量ボディが現場での機動性と最高のパフォーマンスを両立させます。高強度のメンテナンスに最適なパートナーであり、チェンソーを最短時間で現場へ復帰させます。',
  product_lc_003_description: '40V大出力コードレス芝刈り機です。380mm幅の広い刈り幅で大きな庭の管理に最適。大容量バッテリーで一回の充電で広い面積の管理が可能です。',
  product_lc_004_description: '20Vブラシレスコードレスヘッジトリマーです。600mmの長いブレードで生け垣の整形を効率的に実施。電子速度制御で枝の太さに応じた調整が可能です。',
  product_lc_005_description: '20Vコードレス芝梳き機です。芝生の通気改善と枯れ草除去に特化したモデル。定期的なエアレーション作業で芝の健康を促進します。',
  product_lc_006_description: '20Vコードレス芝端刈り機です。芝生の縁を垂直に整え美しい境界線を作るエッジャー。縁石や歩道沿いの仕上げ作業に威力を発揮します。',
  product_lc_007_description: '20V多機能コードレスガーデンメンテナンスセットです。草刈り・エッジング・ブローの3機能がワンセットに。一台で庭の仕上げ管理を完結できます。',
  product_lc_008_description: '40Vブラシレスプロ仕様コードレス芝刈り機です。大型庭園・公園・ゴルフ場周辺の芝管理に最適なプロ向けモデル。高耐久設計で長期間の専業使用に対応します。',
  product_lc_009_description: '20Vコードレス割草機です。ナイロンカッターと金属刃に対応した二刀流モデル。雑草・細い低木・茂みの刈り取りに威力を発揮します。',
  product_lc_010_description: '20Vプロフェッショナルコードレス総合庭園管理セットです。充電器・予備バッテリー・複数のアタッチメントが付属した完全なガーデンケアソリューションです。',

  // 工坊 ポリッシャー (pol-001~010)
  product_pol_001_description: 'LCD スマート制御、定電力補正、8mm 偏心技術を融合させた 20V プロ仕様ポリッシャー。極上の鏡面仕上げと効率的な修復を追求する方に最適です。',
  product_pol_002_description: '150mmロータリーカーポリッシャーです。高出力ロータリーモーターで深い傷の除去と塗装面の快速研磨に特化。プロのカーディテイラー向けモデルです。',
  product_pol_003_description: '125mmミニカーポリッシャーです。コンパクトサイズで狭いパネル・バンパー・ミラーの研磨に最適。軽量設計で細かい部分の作業も疲れにくいです。',
  product_pol_004_description: '200mm大径カーポリッシャーです。広いパッド面積でルーフやボンネットなどの大面積を効率的に研磨。作業時間を大幅に短縮できるプロ向けモデルです。',
  product_pol_005_description: '180mm可変速カーポリッシャーです。1500-6800OPMの広い速度範囲で粗研磨から最終仕上げまで一台でカバー。電子速度制御で安定した研磨品質を実現します。',
  product_pol_006_description: '150mmデュアルモードカーポリッシャーです。ロータリーとデュアルアクションのモードを切り替え可能。用途に応じた最適な研磨動作を選べる万能モデルです。',
  product_pol_007_description: '125mmコードレスカーポリッシャーです。20Vリチウムバッテリーで電源コードの制約なく自由に研磨。アウトドアカーウォッシュや駐車場での作業に最適です。',
  product_pol_008_description: '180mmエアポリッシャーです。コンプレッザー接続型で安定した圧縮空気を動力源とするプロ塗装工場向けモデル。軽量で連続稼働に優れています。',
  product_pol_009_description: '150mmウェットカーポリッシャーです。水使用対応の特殊設計で水研ぎ専用の超精密仕上げが可能。完璧な鏡面仕上げを求めるプロ向けモデルです。',
  product_pol_010_description: '180mmスマートカーポリッシャーです。電子負荷感知機能が塗装面への圧力を自動モニタリング。過圧による塗装へのダメージを防止するプレミアムモデルです。',

  // 工坊 サンダー (san-001~010)
  product_san_001_description: '125mm偏心軌道サンダーのスタンダードモデルです。精密な偏心動作で均一な木材表面仕上げを実現。マジックテープ式サンドペーパーで素早い交換が可能です。',
  product_san_002_description: '150mmランダム軌道サンダーです。ランダムな軌道運動で研磨目を残さない自然な仕上がりを実現。木材の最終仕上げや塗料下処理に最適なモデルです。',
  product_san_003_description: '100mm三角形ディテールサンダーです。角や細部の研磨に特化した三角形パッド採用。家具・キャビネット・窓枠などの複雑な形状の仕上げに威力を発揮します。',
  product_san_004_description: '200mmワイドベルトサンダーです。広幅サンドベルトで大面積の素早い研磨に特化。フロア・大型パネル・テーブル天板の大量研磨作業に最適です。',
  product_san_005_description: '125mm可変速サンダーです。4000-12000OPMの速度調整で素材に合わせた最適な研磨速度を選択可能。デリケートな素材から粗削りまで幅広く対応します。',
  product_san_006_description: '150mm乾湿両用サンダーです。乾式・湿式両方の研磨に対応した特殊防水設計。自動車パネルの水研ぎや防水素材の研磨に威力を発揮するモデルです。',
  product_san_007_description: '125mmコードレス軌道サンダーです。20Vリチウムバッテリー搭載で電源不要の自由な移動が可能。屋外木工作業や現場での仕上げ作業に最適です。',
  product_san_008_description: '100mmエアパームサンダーです。コンプレッザー接続型の軽量コンパクトモデル。片手操作で細部の研磨作業を快適に実施できるプロ向けツールです。',
  product_san_009_description: '150mm壁・天井サンダーです。伸縮ポール対応の特殊設計で壁面や天井の研磨・塗料剥離に特化。リフォーム施工で威力を発揮するユニークなモデルです。',
  product_san_010_description: '125mm静音サンダーです。防音設計で従来品比30%の低騒音を実現。住宅内での作業や夜間の室内木工に最適な静音ツールです。',

  // 工坊 グルーガン (glue-001~010)
  product_glue_001_description: '15秒の高速予熱と 0.25kg の超軽量ボディを兼ね備えた 4V コードレスグルーガン。クリエイティブなハンドメイドや家庭の補修に最適な一台です。',
  product_glue_002_description: '15秒の高速予熱と優れたバッテリー寿命を完璧に融合させた12Vプロ仕様グルーガン。工業用補修や大規模なDIY制作に最適な効率的ツールです。',
  product_glue_003_description: 'フルオート送りシステムを搭載した 20V フラッグシップモデル。13g/min の工業用供給スピードを誇り、重負荷の改装、木工作業、大規模なクリエイティブ制作に最適です。',
  product_glue_004_description: '120Wデュアル温度ホットグルーガンです。低温・高温の2モード切替で様々な素材への接着に対応。デリケートな花材から硬質素材まで幅広く使用できます。',
  product_glue_005_description: '80Wコードレスホットグルーガンです。20Vリチウムバッテリー搭載で電源コードなしに自由に移動しながら接着作業が可能。アウトドアクラフトにも最適です。',
  product_glue_006_description: '100W精密ホットグルーガンです。細口精密ノズル搭載で微細な量のホットグルー塗布が可能。精密模型・電子部品固定・フラワーアレンジメントに最適なモデルです。',
  product_glue_007_description: '150W工業用ホットグルーガンです。高出力で大量のホットグルー供給が可能なプロ向けモデル。包装・製造ライン・大型クラフト制作での大量接着作業に対応します。',
  product_glue_008_description: '80Wスマートホットグルーガンです。自動温度制御機能が最適接着温度を維持。過熱防止センサーと自動スリープ機能で安全性を高めたインテリジェントモデルです。',
  product_glue_009_description: '100Wデュアルノズルホットグルーガンです。2本のノズルを素早く切り替えられる独自設計。細部の精密塗布と大面積の素早い塗布をワンツールで切り替えて使用できます。',
  product_glue_010_description: '80Wロングノズルホットグルーガンです。150mmの長いノズルで深い場所や狭いスペースへのホットグルー注入が可能。電子部品の接着や深部への修理に最適なモデルです。',

  // 磨刀 ワークベンチ (wb-001~010)
  product_wb_001_description: '3つのサンディングモードを一体化した 220W 変速サンダー。強力な集塵機能と優れた人間工学設計により、複雑な表面処理を軽快、精密、そしてクリーンに行えます。',
  product_wb_002_description: 'ドリルビットの修復、刃物の研ぎ、ノミの研磨を一体化した 65W 多機能研磨機。精密な角度調節システムにより、お使いのツールを常に最高の切れ味に保ちます。',
  product_wb_003_description: '40,000rpm の高速回転と42点の多機能アクセサリーを融合させた 160W プロ仕様ミニルーター。DIY、模型製作、精密な芸術修復に最適な万能ツールです。',
  product_wb_004_description: 'S1S-DW03-50DC は、20V コードレスの利便性と工業用研削効率を兼ね備えた卓上グラインダーです。最大 9000 rpm の高速回転とデュアル粒度ホイールにより、刃物の研ぎ直しや小型部品の研磨、DIY 制作に最適なプロ向けツールです。',
  product_wb_005_description: ' S1S-DW07-75 は、精密加工用に設計された 120W AC 卓上研削・研磨ワークステーションです。デュアルホイールシステムとフレキシブルシャフトを統合し、11,500 rpm の強力な出力で、ジュエリー修復や模型製作、精密な金属仕上げに最適です。',
  product_wb_006_description: 'ポータブル磨刀工作台です。折りたたみ設計で重量わずか4kgと持ち運びが楽。現場での刃物研ぎやアウトドア用途にも対応する移動型モデルです。',
  product_wb_007_description: '重作業用研削ワークベンチです。大型砥石と強力モーター搭載で大きな工具や厚い刃物の大量研削に対応。鍛冶工房やプロ工具メンテナンス向けです。',
  product_wb_008_description: 'スマート磨刀システムです。AI角度認識機能が刃物の形状を自動判定し最適な研磨プログラムを提案。デジタル管理で研磨の再現性を高めます。',
  product_wb_009_description: '包丁専用磨刀ステーションです。日本刀・中華包丁・洋包丁の各形状に対応したシステム。家庭の厨房でプロ品質の切れ味を維持できる使いやすいモデルです。',
  product_wb_010_description: '工業用研磨プラットフォームです。大量生産ラインでの刃物の定期的な一括研磨に対応。高スループットと一貫した品質管理を実現するプロ工場向けモデルです。',

  // 磨刀 ドリル修復機 (dr-001~010)
  product_dr_001_description: 'S1S-DW07-75 は、精密加工用に設計された AC 卓上ワークステーションです。卓上グラインダーの安定性とフレキシブルシャフトツールの柔軟性を巧みに融合。信頼性の高い 120W のパワー と 2 つの透明安全シールド により、模型製作、ジュエリーの修復、小型部品の仕上げに効率的で安全なプロフェッショナルな環境を提供します。',
  product_dr_002_description: 'S1Z-DW03-75 は、摩耗したドリルの効率的な修復用に設計された 95W AC ドリル研磨機です。精密なポジショニングホールと安定した出力により、初心者でも 3-12mm のドリルを簡単に研ぐことができ、工具の寿命を延ばし作業効率を高めるための理想的なアシスタントです。',
  product_dr_003_description: 'S1Z-DW04-58 は、コンパクトな 95W AC 卓上ドリル研磨機です。高精度なポジショニングガイドと安定した出力を組み合わせ、切れ味の鈍くなった Ф3-10mm のドリルをプロ仕様のレベルに素早く復元。効率的でコストパフォーマンスの高い工具メンテナンスを求めるプロフェッショナルに最適です。',
  product_dr_004_description: 'S1Z-DW08-75 は、一般的な 3-13mm 規格向けに設計されたプロ仕様のドリル研磨機です。95W の効率的なパワーを維持しつつ、構造の最適化により広いクランプ範囲を実現。ワークショップで鈍くなったドリルを修復し、作業精度を維持するための信頼できるソリューションです。',
  product_dr_005_description: 'S1Z-DW09-92W は、ヘビーユースや工業用グレードの精度向けに設計されたドリル研磨ステーションです。115°-140°の可変ポイントアングル機能、安定した 92W AC パワー、ダイヤモンド研磨技術を備え、最大 19mm の大型ドリルも効率的に処理。工場のメンテナンスルームや高度なワークショップに最適です。',
  product_dr_006_description: '自動送りドリルビット研磨機です。自動送りシステムで熟練不要の一定品質の研削を実現。研削量と研削角度を事前設定するだけで自動的に処理します。',
  product_dr_007_description: '高速ドリルビット修復機です。高速研削サイクルで1本あたり30秒以内の素早い修復を実現。大量のビットを短時間で処理できる生産ライン向けモデルです。',
  product_dr_008_description: 'CNCドリルビット研磨機です。数値制御による高精度な全自動研削システム。プログラム設定で複数の研削プロファイルを記憶・再現できるスマートモデルです。',
  product_dr_009_description: '小径ドリルビット研磨機です。0.5-6mmの細いドリルビットの修復に特化。プリント基板製造や精密機械加工向けの超精密小径ビット専用モデルです。',
  product_dr_010_description: '工業用ドリルビット研磨機です。HSS・超硬・コバルト各素材のビットに対応した高耐久産業用モデル。製造工場での大量のビットのメンテナンス管理に最適です。',

  // 磨刀 彫刻ツール (eg-001~010)
  product_eg_001_description: 'Q0K-DW05-4V は、究極の携帯性と多機能性を兼ね備えたリチウム電池式彫刻ペンです。3.2mm 汎用チャック、最大 19,000/min のストローク速度、6 段階の調整機能を備え、プロのマーキングから工芸製作、家庭での DIY まで幅広く活躍するコードレスソリューションです。',
  product_eg_002_description: 'Q1K-DW04-13 は、高精度なマーキング用に設計された AC 電源式電気彫刻機です。工業部品の番号刻印からギフトのサイン入れまで、安定した出力と軽量なボディでプロ仕様の彫刻体験を提供します。',
  product_eg_003_description: '精密彫刻ツールセットです。本体に加え20種類以上の専用ビットが付属した完全セット。彫刻・研削・研磨・切断など様々な作業に対応する入門から上級者向けパッケージです。',
  product_eg_004_description: 'コードレスリチウム彫刻ペンです。20Vバッテリー駆動でコードの制約なく自由な彫刻が可能。屋外でのアート制作や現場での刻印作業にも対応する機動力の高いモデルです。',
  product_eg_005_description: '30,000RPM高速彫刻機です。超高回転でガラス・セラミック・石材への彫刻が可能。プロのガラス職人や宝飾師が求める精密ディテール表現を実現するフラッグシップモデルです。',
  product_eg_006_description: 'マイクロ彫刻ツールです。0.3mm以下の超精細加工に対応した精密モデル。ジュエリー制作・時計修理・電子部品の精密マーキングに最適な特殊ツールです。',
  product_eg_007_description: 'プロフェッショナル彫刻システムです。電子速度制御と多彫刻モード搭載の本格モデル。彫刻スタジオや工芸工房のプロフェッショナルが求める精度と耐久性を実現します。',
  product_eg_008_description: '木工彫刻専用ツールです。木材の繊維に合わせた最適な彫刻ビット形状と制御設計。木工師傅や木彫り愛好家のための木材彫刻専用に最適化されたモデルです。',
  product_eg_009_description: '金属彫刻機です。鋼・アルミ・銅などの金属表面への刻印・装飾・マーキングに特化。産業用品のシリアルナンバー刻印や金属工芸品の装飾に威力を発揮します。',
  product_eg_010_description: 'アーティスト向け彫刻ツールセットです。初心者アーティストから上級者まで対応した総合創作セット。詳細な使い方ガイドと豊富なサンプルパターン集が付属する学習向けパッケージです。',

  // ===== 磨刀シリーズ 製品名・型番 =====
  'products.sharpening.categories.workbench': '多機能研削ワークベンチ',
  'products.sharpening.categories.drillRepair': 'ドリルビット修理機',
  'products.sharpening.categories.engraving': '彫刻ツール',
  'products.sharpening.workbench.001.name': '220W 3in1 マルチサンダー',
  'products.sharpening.workbench.001.model': 'S1B-DW01-220W',
  'products.sharpening.workbench.001.description': '220W 3in1 マルチサンダー',
  'products.sharpening.workbench.002.name': '95W ドリルシャープナー',
  'products.sharpening.workbench.002.model': 'S1D-DW05-52 ',
  'products.sharpening.workbench.002.description': '95W ドリルシャープナー',
  'products.sharpening.workbench.003.name': '160W ミニルーター',
  'products.sharpening.workbench.003.model': 'S1J-DW02-160',
  'products.sharpening.workbench.003.description': '160W ミニルーター',
  'products.sharpening.workbench.004.name': '20V コードレス両頭グラインダー',
  'products.sharpening.workbench.004.model': 'S1S-DW03-50DC',
  'products.sharpening.workbench.004.description': '20V コードレス両頭グラインダー',
  'products.sharpening.workbench.005.name': '20W 両頭グラインダー',
  'products.sharpening.workbench.005.model': 'S1S-DW07-75',
  'products.sharpening.workbench.005.description': '20W 両頭グラインダー',
  'products.sharpening.workbench.006.name': 'ポータブル研削ワークベンチ',
  'products.sharpening.workbench.006.model': 'LK-SP-WB-PT-006',
  'products.sharpening.workbench.006.description': '軽量設計のポータブル研削ワークベンチ',
  'products.sharpening.workbench.007.name': '重型研削ワークベンチ',
  'products.sharpening.workbench.007.model': 'LK-SP-WB-HD-007',
  'products.sharpening.workbench.007.description': '大型工具向けの重型研削ワークベンチ',
  'products.sharpening.workbench.008.name': 'スマート研削システム',
  'products.sharpening.workbench.008.model': 'LK-SP-WB-SM-008',
  'products.sharpening.workbench.008.description': '自動角度認識付きスマート研削システム',
  'products.sharpening.workbench.009.name': '包丁専用研削ステーション',
  'products.sharpening.workbench.009.model': 'LK-SP-WB-KN-009',
  'products.sharpening.workbench.009.description': '操作が簡単なプロフェッショナル包丁研削ステーション',
  'products.sharpening.workbench.010.name': '工業用研削プラットフォーム',
  'products.sharpening.workbench.010.model': 'LK-SP-WB-IN-010',
  'products.sharpening.workbench.010.description': '量産対応の工業用研削プラットフォーム',

  'products.sharpening.drillRepair.001.name': '3in1 ドリルシャープナー',
  'products.sharpening.drillRepair.001.model': 'S1D-DW03-58',
  'products.sharpening.drillRepair.001.description': '3in1 ドリルシャープナー',
  'products.sharpening.drillRepair.002.name': '95W ドリルシャープナー',
  'products.sharpening.drillRepair.002.model': 'S1Z-DW03-75',
  'products.sharpening.drillRepair.002.description': '95W ドリルシャープナー',
  'products.sharpening.drillRepair.003.name': '95W ドリルシャープナー',
  'products.sharpening.drillRepair.003.model': 'S1Z-DW04-58',
  'products.sharpening.drillRepair.003.description': '95W ドリルシャープナー',
  'products.sharpening.drillRepair.004.name': '95W ドリルシャープナー',
  'products.sharpening.drillRepair.004.model': 'S1Z-DW08-75',
  'products.sharpening.drillRepair.004.description': '95W ドリルシャープナー',
  'products.sharpening.drillRepair.005.name': '92W ドリルシャープナー',
  'products.sharpening.drillRepair.005.model': 'S1Z-DW09-92W',
  'products.sharpening.drillRepair.005.description': '92W ドリルシャープナー',
  'products.sharpening.drillRepair.006.name': '自動ドリルビット研削機',
  'products.sharpening.drillRepair.006.model': 'LK-SP-DR-AT-006',
  'products.sharpening.drillRepair.006.description': '自動送りシステム付きドリルビット研削機',
  'products.sharpening.drillRepair.007.name': '高速ドリルビット修復機',
  'products.sharpening.drillRepair.007.model': 'LK-SP-DR-HS-007',
  'products.sharpening.drillRepair.007.description': '高速量産対応のドリルビット修復機',
  'products.sharpening.drillRepair.008.name': 'CNCドリルビット研削機',
  'products.sharpening.drillRepair.008.model': 'LK-SP-DR-CN-008',
  'products.sharpening.drillRepair.008.description': '数値制御システム付きCNCドリルビット研削機',
  'products.sharpening.drillRepair.009.name': '小径ドリルビット研削機',
  'products.sharpening.drillRepair.009.model': 'LK-SP-DR-SM-009',
  'products.sharpening.drillRepair.009.description': '小径ドリルビット専用研削機',
  'products.sharpening.drillRepair.010.name': '工業用ドリルビット研削機',
  'products.sharpening.drillRepair.010.model': 'LK-SP-DR-IN-010',
  'products.sharpening.drillRepair.010.description': '量産対応の工業用ドリルビット研削機',

  'products.sharpening.engraving.001.name': '4V コードレスミニルーター',
  'products.sharpening.engraving.001.model': 'Q0K-DW05-4V',
  'products.sharpening.engraving.001.description': '4V コードレスミニルーター',
  'products.sharpening.engraving.002.name': '13W 電動刻印ペン',
  'products.sharpening.engraving.002.model': 'Q1K-DW04-13',
  'products.sharpening.engraving.002.description': '13W 電動刻印ペン',
  'products.sharpening.engraving.003.name': '精密彫刻ツールセット',
  'products.sharpening.engraving.003.model': 'LK-SP-EG-PR-003',
  'products.sharpening.engraving.003.description': '複数ビットと付属品付きの精密彫刻ツールセット',
  'products.sharpening.engraving.004.name': 'コードレスリチウム彫刻ペン',
  'products.sharpening.engraving.004.model': 'LK-SP-EG-CL-004',
  'products.sharpening.engraving.004.description': 'モバイル作業対応のリチウム電池式コードレス彫刻ペン',
  'products.sharpening.engraving.005.name': '高速彫刻機',
  'products.sharpening.engraving.005.model': 'LK-SP-EG-HS-005',
  'products.sharpening.engraving.005.description': '高速作業対応の30000RPM高速彫刻機',
  'products.sharpening.engraving.006.name': 'マイクロ彫刻ツール',
  'products.sharpening.engraving.006.model': 'LK-SP-EG-MC-006',
  'products.sharpening.engraving.006.description': '精細・精密作業対応のマイクロ彫刻ツール',
  'products.sharpening.engraving.007.name': 'プロフェッショナル彫刻システム',
  'products.sharpening.engraving.007.model': 'LK-SP-EG-PF-007',
  'products.sharpening.engraving.007.description': '調速と複数モード付きのプロフェッショナル彫刻システム',
  'products.sharpening.engraving.008.name': '木工彫刻ツール',
  'products.sharpening.engraving.008.model': 'LK-SP-EG-WD-008',
  'products.sharpening.engraving.008.description': '木彫り専用に設計された木工彫刻ツール',
  'products.sharpening.engraving.009.name': '金属彫刻機',
  'products.sharpening.engraving.009.model': 'LK-SP-EG-MT-009',
  'products.sharpening.engraving.009.description': '金属表面のマーキングと彫刻向けの金属彫刻機',
  'products.sharpening.engraving.010.name': 'アーティスト彫刻ツールセット',
  'products.sharpening.engraving.010.model': 'LK-SP-EG-AT-010',
  'products.sharpening.engraving.010.description': 'クリエイティブ作業向けのプロフェッショナルアーティスト彫刻ツールセット',
};

export default translation;